import { j as it } from "./utils-BdNIfrGQ.js";
import { useEffect as ee, useContext as Hr, useState as te, useRef as ot, createContext as Yr, useCallback as lt, useMemo as Ze } from "react";
import { g as se } from "./_commonjsHelpers-DaMA6jEr.js";
var ae = {}, er;
function st() {
  if (er) return ae;
  er = 1, ae.match = n, ae.parse = r;
  var e = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, u = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, a = /^(?:(min|max)-)?(.+)/, o = /(em|rem|px|cm|mm|in|pt|pc)?$/, i = /(dpi|dpcm|dppx)?$/;
  function n(f, c) {
    return r(f).some(function(d) {
      var v = d.inverse, h = d.type === "all" || c.type === d.type;
      if (h && v || !(h || v))
        return !1;
      var O = d.expressions.every(function(P) {
        var q = P.feature, U = P.modifier, k = P.value, M = c[q];
        if (!M)
          return !1;
        switch (q) {
          case "orientation":
          case "scan":
            return M.toLowerCase() === k.toLowerCase();
          case "width":
          case "height":
          case "device-width":
          case "device-height":
            k = t(k), M = t(M);
            break;
          case "resolution":
            k = l(k), M = l(M);
            break;
          case "aspect-ratio":
          case "device-aspect-ratio":
          case /* Deprecated */
          "device-pixel-ratio":
            k = p(k), M = p(M);
            break;
          case "grid":
          case "color":
          case "color-index":
          case "monochrome":
            k = parseInt(k, 10) || 1, M = parseInt(M, 10) || 0;
            break;
        }
        switch (U) {
          case "min":
            return M >= k;
          case "max":
            return M <= k;
          default:
            return M === k;
        }
      });
      return O && !v || !O && v;
    });
  }
  function r(f) {
    return f.split(",").map(function(c) {
      c = c.trim();
      var d = c.match(e), v = d[1], h = d[2], O = d[3] || "", P = {};
      return P.inverse = !!v && v.toLowerCase() === "not", P.type = h ? h.toLowerCase() : "all", O = O.match(/\([^\)]+\)/g) || [], P.expressions = O.map(function(q) {
        var U = q.match(u), k = U[1].toLowerCase().match(a);
        return {
          modifier: k[1],
          feature: k[2],
          value: U[2]
        };
      }), P;
    });
  }
  function p(f) {
    var c = Number(f), d;
    return c || (d = f.match(/^(\d+)\s*\/\s*(\d+)$/), c = d[1] / d[2]), c;
  }
  function l(f) {
    var c = parseFloat(f), d = String(f).match(i)[1];
    switch (d) {
      case "dpcm":
        return c / 2.54;
      case "dppx":
        return c * 96;
      default:
        return c;
    }
  }
  function t(f) {
    var c = parseFloat(f), d = String(f).match(o)[1];
    switch (d) {
      case "em":
        return c * 16;
      case "rem":
        return c * 16;
      case "cm":
        return c * 96 / 2.54;
      case "mm":
        return c * 96 / 2.54 / 10;
      case "in":
        return c * 96;
      case "pt":
        return c * 72;
      case "pc":
        return c * 72 / 12;
      default:
        return c;
    }
  }
  return ae;
}
var ue, rr;
function ut() {
  if (rr) return ue;
  rr = 1;
  var e = st().match, u = typeof window < "u" ? window.matchMedia : null;
  function a(i, n, r) {
    var p = this, l;
    u && !r && (l = u.call(window, i)), l ? (this.matches = l.matches, this.media = l.media, l.addListener(c)) : (this.matches = e(i, n), this.media = i), this.addListener = t, this.removeListener = f, this.dispose = d;
    function t(v) {
      l && l.addListener(v);
    }
    function f(v) {
      l && l.removeListener(v);
    }
    function c(v) {
      p.matches = v.matches, p.media = v.media;
    }
    function d() {
      l && l.removeListener(c);
    }
  }
  function o(i, n, r) {
    return new a(i, n, r);
  }
  return ue = o, ue;
}
var ct = ut();
const ft = /* @__PURE__ */ se(ct);
var dt = /[A-Z]/g, pt = /^ms-/, ce = {};
function mt(e) {
  return "-" + e.toLowerCase();
}
function Gr(e) {
  if (ce.hasOwnProperty(e))
    return ce[e];
  var u = e.replace(dt, mt);
  return ce[e] = pt.test(u) ? "-" + u : u;
}
function gt(e, u) {
  if (e === u)
    return !0;
  if (!e || !u)
    return !1;
  const a = Object.keys(e), o = Object.keys(u), i = a.length;
  if (o.length !== i)
    return !1;
  for (let n = 0; n < i; n++) {
    const r = a[n];
    if (e[r] !== u[r] || !Object.prototype.hasOwnProperty.call(u, r))
      return !1;
  }
  return !0;
}
var ie = { exports: {} }, oe = { exports: {} }, Y = {};
var tr;
function vt() {
  if (tr) return Y;
  tr = 1;
  var e = typeof Symbol == "function" && Symbol.for, u = e ? /* @__PURE__ */ Symbol.for("react.element") : 60103, a = e ? /* @__PURE__ */ Symbol.for("react.portal") : 60106, o = e ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107, i = e ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108, n = e ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114, r = e ? /* @__PURE__ */ Symbol.for("react.provider") : 60109, p = e ? /* @__PURE__ */ Symbol.for("react.context") : 60110, l = e ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111, t = e ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111, f = e ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112, c = e ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113, d = e ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120, v = e ? /* @__PURE__ */ Symbol.for("react.memo") : 60115, h = e ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116, O = e ? /* @__PURE__ */ Symbol.for("react.block") : 60121, P = e ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117, q = e ? /* @__PURE__ */ Symbol.for("react.responder") : 60118, U = e ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
  function k(y) {
    if (typeof y == "object" && y !== null) {
      var D = y.$$typeof;
      switch (D) {
        case u:
          switch (y = y.type, y) {
            case l:
            case t:
            case o:
            case n:
            case i:
            case c:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case p:
                case f:
                case h:
                case v:
                case r:
                  return y;
                default:
                  return D;
              }
          }
        case a:
          return D;
      }
    }
  }
  function M(y) {
    return k(y) === t;
  }
  return Y.AsyncMode = l, Y.ConcurrentMode = t, Y.ContextConsumer = p, Y.ContextProvider = r, Y.Element = u, Y.ForwardRef = f, Y.Fragment = o, Y.Lazy = h, Y.Memo = v, Y.Portal = a, Y.Profiler = n, Y.StrictMode = i, Y.Suspense = c, Y.isAsyncMode = function(y) {
    return M(y) || k(y) === l;
  }, Y.isConcurrentMode = M, Y.isContextConsumer = function(y) {
    return k(y) === p;
  }, Y.isContextProvider = function(y) {
    return k(y) === r;
  }, Y.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === u;
  }, Y.isForwardRef = function(y) {
    return k(y) === f;
  }, Y.isFragment = function(y) {
    return k(y) === o;
  }, Y.isLazy = function(y) {
    return k(y) === h;
  }, Y.isMemo = function(y) {
    return k(y) === v;
  }, Y.isPortal = function(y) {
    return k(y) === a;
  }, Y.isProfiler = function(y) {
    return k(y) === n;
  }, Y.isStrictMode = function(y) {
    return k(y) === i;
  }, Y.isSuspense = function(y) {
    return k(y) === c;
  }, Y.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === o || y === t || y === n || y === i || y === c || y === d || typeof y == "object" && y !== null && (y.$$typeof === h || y.$$typeof === v || y.$$typeof === r || y.$$typeof === p || y.$$typeof === f || y.$$typeof === P || y.$$typeof === q || y.$$typeof === U || y.$$typeof === O);
  }, Y.typeOf = k, Y;
}
var G = {};
var nr;
function ht() {
  return nr || (nr = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = typeof Symbol == "function" && Symbol.for, u = e ? /* @__PURE__ */ Symbol.for("react.element") : 60103, a = e ? /* @__PURE__ */ Symbol.for("react.portal") : 60106, o = e ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107, i = e ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108, n = e ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114, r = e ? /* @__PURE__ */ Symbol.for("react.provider") : 60109, p = e ? /* @__PURE__ */ Symbol.for("react.context") : 60110, l = e ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111, t = e ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111, f = e ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112, c = e ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113, d = e ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120, v = e ? /* @__PURE__ */ Symbol.for("react.memo") : 60115, h = e ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116, O = e ? /* @__PURE__ */ Symbol.for("react.block") : 60121, P = e ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117, q = e ? /* @__PURE__ */ Symbol.for("react.responder") : 60118, U = e ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
    function k(A) {
      return typeof A == "string" || typeof A == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      A === o || A === t || A === n || A === i || A === c || A === d || typeof A == "object" && A !== null && (A.$$typeof === h || A.$$typeof === v || A.$$typeof === r || A.$$typeof === p || A.$$typeof === f || A.$$typeof === P || A.$$typeof === q || A.$$typeof === U || A.$$typeof === O);
    }
    function M(A) {
      if (typeof A == "object" && A !== null) {
        var Z = A.$$typeof;
        switch (Z) {
          case u:
            var ne = A.type;
            switch (ne) {
              case l:
              case t:
              case o:
              case n:
              case i:
              case c:
                return ne;
              default:
                var Je = ne && ne.$$typeof;
                switch (Je) {
                  case p:
                  case f:
                  case h:
                  case v:
                  case r:
                    return Je;
                  default:
                    return Z;
                }
            }
          case a:
            return Z;
        }
      }
    }
    var y = l, D = t, W = p, K = r, x = u, S = f, w = o, m = h, E = v, _ = a, b = n, T = i, g = c, R = !1;
    function $(A) {
      return R || (R = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), s(A) || M(A) === l;
    }
    function s(A) {
      return M(A) === t;
    }
    function C(A) {
      return M(A) === p;
    }
    function j(A) {
      return M(A) === r;
    }
    function z(A) {
      return typeof A == "object" && A !== null && A.$$typeof === u;
    }
    function L(A) {
      return M(A) === f;
    }
    function B(A) {
      return M(A) === o;
    }
    function F(A) {
      return M(A) === h;
    }
    function I(A) {
      return M(A) === v;
    }
    function N(A) {
      return M(A) === a;
    }
    function X(A) {
      return M(A) === n;
    }
    function V(A) {
      return M(A) === i;
    }
    function J(A) {
      return M(A) === c;
    }
    G.AsyncMode = y, G.ConcurrentMode = D, G.ContextConsumer = W, G.ContextProvider = K, G.Element = x, G.ForwardRef = S, G.Fragment = w, G.Lazy = m, G.Memo = E, G.Portal = _, G.Profiler = b, G.StrictMode = T, G.Suspense = g, G.isAsyncMode = $, G.isConcurrentMode = s, G.isContextConsumer = C, G.isContextProvider = j, G.isElement = z, G.isForwardRef = L, G.isFragment = B, G.isLazy = F, G.isMemo = I, G.isPortal = N, G.isProfiler = X, G.isStrictMode = V, G.isSuspense = J, G.isValidElementType = k, G.typeOf = M;
  })()), G;
}
var ar;
function Xr() {
  return ar || (ar = 1, process.env.NODE_ENV === "production" ? oe.exports = vt() : oe.exports = ht()), oe.exports;
}
var fe, ir;
function yt() {
  if (ir) return fe;
  ir = 1;
  var e = Object.getOwnPropertySymbols, u = Object.prototype.hasOwnProperty, a = Object.prototype.propertyIsEnumerable;
  function o(n) {
    if (n == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(n);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var n = new String("abc");
      if (n[5] = "de", Object.getOwnPropertyNames(n)[0] === "5")
        return !1;
      for (var r = {}, p = 0; p < 10; p++)
        r["_" + String.fromCharCode(p)] = p;
      var l = Object.getOwnPropertyNames(r).map(function(f) {
        return r[f];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var t = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        t[f] = f;
      }), Object.keys(Object.assign({}, t)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return fe = i() ? Object.assign : function(n, r) {
    for (var p, l = o(n), t, f = 1; f < arguments.length; f++) {
      p = Object(arguments[f]);
      for (var c in p)
        u.call(p, c) && (l[c] = p[c]);
      if (e) {
        t = e(p);
        for (var d = 0; d < t.length; d++)
          a.call(p, t[d]) && (l[t[d]] = p[t[d]]);
      }
    }
    return l;
  }, fe;
}
var de, or;
function Ge() {
  if (or) return de;
  or = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return de = e, de;
}
var pe, lr;
function Kr() {
  return lr || (lr = 1, pe = Function.call.bind(Object.prototype.hasOwnProperty)), pe;
}
var me, sr;
function bt() {
  if (sr) return me;
  sr = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var u = /* @__PURE__ */ Ge(), a = {}, o = /* @__PURE__ */ Kr();
    e = function(n) {
      var r = "Warning: " + n;
      typeof console < "u" && console.error(r);
      try {
        throw new Error(r);
      } catch {
      }
    };
  }
  function i(n, r, p, l, t) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in n)
        if (o(n, f)) {
          var c;
          try {
            if (typeof n[f] != "function") {
              var d = Error(
                (l || "React class") + ": " + p + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof n[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw d.name = "Invariant Violation", d;
            }
            c = n[f](r, f, l, p, null, u);
          } catch (h) {
            c = h;
          }
          if (c && !(c instanceof Error) && e(
            (l || "React class") + ": type specification of " + p + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof c + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), c instanceof Error && !(c.message in a)) {
            a[c.message] = !0;
            var v = t ? t() : "";
            e(
              "Failed " + p + " type: " + c.message + (v ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (a = {});
  }, me = i, me;
}
var ge, ur;
function xt() {
  if (ur) return ge;
  ur = 1;
  var e = Xr(), u = yt(), a = /* @__PURE__ */ Ge(), o = /* @__PURE__ */ Kr(), i = /* @__PURE__ */ bt(), n = function() {
  };
  process.env.NODE_ENV !== "production" && (n = function(p) {
    var l = "Warning: " + p;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function r() {
    return null;
  }
  return ge = function(p, l) {
    var t = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function c(s) {
      var C = s && (t && s[t] || s[f]);
      if (typeof C == "function")
        return C;
    }
    var d = "<<anonymous>>", v = {
      array: q("array"),
      bigint: q("bigint"),
      bool: q("boolean"),
      func: q("function"),
      number: q("number"),
      object: q("object"),
      string: q("string"),
      symbol: q("symbol"),
      any: U(),
      arrayOf: k,
      element: M(),
      elementType: y(),
      instanceOf: D,
      node: S(),
      objectOf: K,
      oneOf: W,
      oneOfType: x,
      shape: m,
      exact: E
    };
    function h(s, C) {
      return s === C ? s !== 0 || 1 / s === 1 / C : s !== s && C !== C;
    }
    function O(s, C) {
      this.message = s, this.data = C && typeof C == "object" ? C : {}, this.stack = "";
    }
    O.prototype = Error.prototype;
    function P(s) {
      if (process.env.NODE_ENV !== "production")
        var C = {}, j = 0;
      function z(B, F, I, N, X, V, J) {
        if (N = N || d, V = V || I, J !== a) {
          if (l) {
            var A = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw A.name = "Invariant Violation", A;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Z = N + ":" + I;
            !C[Z] && // Avoid spamming the console because they are often not actionable except for lib authors
            j < 3 && (n(
              "You are manually calling a React.PropTypes validation function for the `" + V + "` prop on `" + N + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), C[Z] = !0, j++);
          }
        }
        return F[I] == null ? B ? F[I] === null ? new O("The " + X + " `" + V + "` is marked as required " + ("in `" + N + "`, but its value is `null`.")) : new O("The " + X + " `" + V + "` is marked as required in " + ("`" + N + "`, but its value is `undefined`.")) : null : s(F, I, N, X, V);
      }
      var L = z.bind(null, !1);
      return L.isRequired = z.bind(null, !0), L;
    }
    function q(s) {
      function C(j, z, L, B, F, I) {
        var N = j[z], X = T(N);
        if (X !== s) {
          var V = g(N);
          return new O(
            "Invalid " + B + " `" + F + "` of type " + ("`" + V + "` supplied to `" + L + "`, expected ") + ("`" + s + "`."),
            { expectedType: s }
          );
        }
        return null;
      }
      return P(C);
    }
    function U() {
      return P(r);
    }
    function k(s) {
      function C(j, z, L, B, F) {
        if (typeof s != "function")
          return new O("Property `" + F + "` of component `" + L + "` has invalid PropType notation inside arrayOf.");
        var I = j[z];
        if (!Array.isArray(I)) {
          var N = T(I);
          return new O("Invalid " + B + " `" + F + "` of type " + ("`" + N + "` supplied to `" + L + "`, expected an array."));
        }
        for (var X = 0; X < I.length; X++) {
          var V = s(I, X, L, B, F + "[" + X + "]", a);
          if (V instanceof Error)
            return V;
        }
        return null;
      }
      return P(C);
    }
    function M() {
      function s(C, j, z, L, B) {
        var F = C[j];
        if (!p(F)) {
          var I = T(F);
          return new O("Invalid " + L + " `" + B + "` of type " + ("`" + I + "` supplied to `" + z + "`, expected a single ReactElement."));
        }
        return null;
      }
      return P(s);
    }
    function y() {
      function s(C, j, z, L, B) {
        var F = C[j];
        if (!e.isValidElementType(F)) {
          var I = T(F);
          return new O("Invalid " + L + " `" + B + "` of type " + ("`" + I + "` supplied to `" + z + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return P(s);
    }
    function D(s) {
      function C(j, z, L, B, F) {
        if (!(j[z] instanceof s)) {
          var I = s.name || d, N = $(j[z]);
          return new O("Invalid " + B + " `" + F + "` of type " + ("`" + N + "` supplied to `" + L + "`, expected ") + ("instance of `" + I + "`."));
        }
        return null;
      }
      return P(C);
    }
    function W(s) {
      if (!Array.isArray(s))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? n(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : n("Invalid argument supplied to oneOf, expected an array.")), r;
      function C(j, z, L, B, F) {
        for (var I = j[z], N = 0; N < s.length; N++)
          if (h(I, s[N]))
            return null;
        var X = JSON.stringify(s, function(J, A) {
          var Z = g(A);
          return Z === "symbol" ? String(A) : A;
        });
        return new O("Invalid " + B + " `" + F + "` of value `" + String(I) + "` " + ("supplied to `" + L + "`, expected one of " + X + "."));
      }
      return P(C);
    }
    function K(s) {
      function C(j, z, L, B, F) {
        if (typeof s != "function")
          return new O("Property `" + F + "` of component `" + L + "` has invalid PropType notation inside objectOf.");
        var I = j[z], N = T(I);
        if (N !== "object")
          return new O("Invalid " + B + " `" + F + "` of type " + ("`" + N + "` supplied to `" + L + "`, expected an object."));
        for (var X in I)
          if (o(I, X)) {
            var V = s(I, X, L, B, F + "." + X, a);
            if (V instanceof Error)
              return V;
          }
        return null;
      }
      return P(C);
    }
    function x(s) {
      if (!Array.isArray(s))
        return process.env.NODE_ENV !== "production" && n("Invalid argument supplied to oneOfType, expected an instance of array."), r;
      for (var C = 0; C < s.length; C++) {
        var j = s[C];
        if (typeof j != "function")
          return n(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + R(j) + " at index " + C + "."
          ), r;
      }
      function z(L, B, F, I, N) {
        for (var X = [], V = 0; V < s.length; V++) {
          var J = s[V], A = J(L, B, F, I, N, a);
          if (A == null)
            return null;
          A.data && o(A.data, "expectedType") && X.push(A.data.expectedType);
        }
        var Z = X.length > 0 ? ", expected one of type [" + X.join(", ") + "]" : "";
        return new O("Invalid " + I + " `" + N + "` supplied to " + ("`" + F + "`" + Z + "."));
      }
      return P(z);
    }
    function S() {
      function s(C, j, z, L, B) {
        return _(C[j]) ? null : new O("Invalid " + L + " `" + B + "` supplied to " + ("`" + z + "`, expected a ReactNode."));
      }
      return P(s);
    }
    function w(s, C, j, z, L) {
      return new O(
        (s || "React class") + ": " + C + " type `" + j + "." + z + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + L + "`."
      );
    }
    function m(s) {
      function C(j, z, L, B, F) {
        var I = j[z], N = T(I);
        if (N !== "object")
          return new O("Invalid " + B + " `" + F + "` of type `" + N + "` " + ("supplied to `" + L + "`, expected `object`."));
        for (var X in s) {
          var V = s[X];
          if (typeof V != "function")
            return w(L, B, F, X, g(V));
          var J = V(I, X, L, B, F + "." + X, a);
          if (J)
            return J;
        }
        return null;
      }
      return P(C);
    }
    function E(s) {
      function C(j, z, L, B, F) {
        var I = j[z], N = T(I);
        if (N !== "object")
          return new O("Invalid " + B + " `" + F + "` of type `" + N + "` " + ("supplied to `" + L + "`, expected `object`."));
        var X = u({}, j[z], s);
        for (var V in X) {
          var J = s[V];
          if (o(s, V) && typeof J != "function")
            return w(L, B, F, V, g(J));
          if (!J)
            return new O(
              "Invalid " + B + " `" + F + "` key `" + V + "` supplied to `" + L + "`.\nBad object: " + JSON.stringify(j[z], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(s), null, "  ")
            );
          var A = J(I, V, L, B, F + "." + V, a);
          if (A)
            return A;
        }
        return null;
      }
      return P(C);
    }
    function _(s) {
      switch (typeof s) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !s;
        case "object":
          if (Array.isArray(s))
            return s.every(_);
          if (s === null || p(s))
            return !0;
          var C = c(s);
          if (C) {
            var j = C.call(s), z;
            if (C !== s.entries) {
              for (; !(z = j.next()).done; )
                if (!_(z.value))
                  return !1;
            } else
              for (; !(z = j.next()).done; ) {
                var L = z.value;
                if (L && !_(L[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function b(s, C) {
      return s === "symbol" ? !0 : C ? C["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && C instanceof Symbol : !1;
    }
    function T(s) {
      var C = typeof s;
      return Array.isArray(s) ? "array" : s instanceof RegExp ? "object" : b(C, s) ? "symbol" : C;
    }
    function g(s) {
      if (typeof s > "u" || s === null)
        return "" + s;
      var C = T(s);
      if (C === "object") {
        if (s instanceof Date)
          return "date";
        if (s instanceof RegExp)
          return "regexp";
      }
      return C;
    }
    function R(s) {
      var C = g(s);
      switch (C) {
        case "array":
        case "object":
          return "an " + C;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + C;
        default:
          return C;
      }
    }
    function $(s) {
      return !s.constructor || !s.constructor.name ? d : s.constructor.name;
    }
    return v.checkPropTypes = i, v.resetWarningCache = i.resetWarningCache, v.PropTypes = v, v;
  }, ge;
}
var ve, cr;
function wt() {
  if (cr) return ve;
  cr = 1;
  var e = /* @__PURE__ */ Ge();
  function u() {
  }
  function a() {
  }
  return a.resetWarningCache = u, ve = function() {
    function o(r, p, l, t, f, c) {
      if (c !== e) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    o.isRequired = o;
    function i() {
      return o;
    }
    var n = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: i,
      element: o,
      elementType: o,
      instanceOf: i,
      node: o,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: a,
      resetWarningCache: u
    };
    return n.PropTypes = n, n;
  }, ve;
}
var fr;
function _t() {
  if (fr) return ie.exports;
  if (fr = 1, process.env.NODE_ENV !== "production") {
    var e = Xr(), u = !0;
    ie.exports = /* @__PURE__ */ xt()(e.isElement, u);
  } else
    ie.exports = /* @__PURE__ */ wt()();
  return ie.exports;
}
var Ot = /* @__PURE__ */ _t();
const H = /* @__PURE__ */ se(Ot), Q = H.oneOfType([H.string, H.number]), Qr = {
  all: H.bool,
  grid: H.bool,
  aural: H.bool,
  braille: H.bool,
  handheld: H.bool,
  print: H.bool,
  projection: H.bool,
  screen: H.bool,
  tty: H.bool,
  tv: H.bool,
  embossed: H.bool
}, Et = {
  orientation: H.oneOf(["portrait", "landscape"]),
  scan: H.oneOf(["progressive", "interlace"]),
  aspectRatio: H.string,
  deviceAspectRatio: H.string,
  height: Q,
  deviceHeight: Q,
  width: Q,
  deviceWidth: Q,
  color: H.bool,
  colorIndex: H.bool,
  monochrome: H.bool,
  resolution: Q,
  type: Object.keys(Qr)
}, { type: xn, ...Tt } = Et, Ct = {
  minAspectRatio: H.string,
  maxAspectRatio: H.string,
  minDeviceAspectRatio: H.string,
  maxDeviceAspectRatio: H.string,
  minHeight: Q,
  maxHeight: Q,
  minDeviceHeight: Q,
  maxDeviceHeight: Q,
  minWidth: Q,
  maxWidth: Q,
  minDeviceWidth: Q,
  maxDeviceWidth: Q,
  minColor: H.number,
  maxColor: H.number,
  minColorIndex: H.number,
  maxColorIndex: H.number,
  minMonochrome: H.number,
  maxMonochrome: H.number,
  minResolution: Q,
  maxResolution: Q,
  ...Tt
}, At = { ...Qr, ...Ct };
var kt = {
  all: At
};
const Pt = (e) => `not ${e}`, St = (e, u) => {
  const a = Gr(e);
  return typeof u == "number" && (u = `${u}px`), u === !0 ? a : u === !1 ? Pt(a) : `(${a}: ${u})`;
}, Rt = (e) => e.join(" and "), Mt = (e) => {
  const u = [];
  return Object.keys(kt.all).forEach((a) => {
    const o = e[a];
    o != null && u.push(St(a, o));
  }), Rt(u);
}, Dt = Yr(void 0), qt = (e) => e.query || Mt(e), dr = (e) => e ? Object.keys(e).reduce((a, o) => (a[Gr(o)] = e[o], a), {}) : void 0, Jr = () => {
  const e = ot(!1);
  return ee(() => {
    e.current = !0;
  }, []), e.current;
}, $t = (e) => {
  const u = Hr(Dt), a = () => dr(e) || dr(u), [o, i] = te(a);
  return ee(() => {
    const n = a();
    gt(o, n) || i(n);
  }, [e, u]), o;
}, Lt = (e) => {
  const u = () => qt(e), [a, o] = te(u);
  return ee(() => {
    const i = u();
    a !== i && o(i);
  }, [e]), a;
}, jt = (e, u) => {
  const a = () => ft(e, u || {}, !!u), [o, i] = te(a), n = Jr();
  return ee(() => {
    if (n) {
      const r = a();
      return i(r), () => {
        r && r.dispose();
      };
    }
  }, [e, u]), o;
}, Ft = (e) => {
  const [u, a] = te(e.matches);
  return ee(() => {
    const o = (i) => {
      a(i.matches);
    };
    return e.addListener(o), a(e.matches), () => {
      e.removeListener(o);
    };
  }, [e]), u;
}, re = (e, u, a) => {
  const o = $t(u), i = Lt(e);
  if (!i)
    throw new Error("Invalid or missing MediaQuery!");
  const n = jt(i, o), r = Ft(n);
  return Jr(), ee(() => {
  }, [r]), ee(() => () => {
    n && n.dispose();
  }, []), r;
};
var he = {}, ye = {}, be = {}, pr;
function Zr() {
  return pr || (pr = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return u;
      }
    });
    function u(a) {
      if (a = `${a}`, a === "0")
        return "0";
      if (/^[+-]?(\d+|\d*\.\d+)(e[+-]?\d+)?(%|\w+)?$/.test(a))
        return a.replace(/^[+-]?/, (i) => i === "-" ? "" : "-");
      let o = [
        "var",
        "calc",
        "min",
        "max",
        "clamp"
      ];
      for (const i of o)
        if (a.includes(`${i}(`))
          return `calc(${a} * -1)`;
    }
  })(be)), be;
}
var xe = {}, mr;
function zt() {
  return mr || (mr = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return u;
      }
    });
    const u = [
      "preflight",
      "container",
      "accessibility",
      "pointerEvents",
      "visibility",
      "position",
      "inset",
      "isolation",
      "zIndex",
      "order",
      "gridColumn",
      "gridColumnStart",
      "gridColumnEnd",
      "gridRow",
      "gridRowStart",
      "gridRowEnd",
      "float",
      "clear",
      "margin",
      "boxSizing",
      "lineClamp",
      "display",
      "aspectRatio",
      "size",
      "height",
      "maxHeight",
      "minHeight",
      "width",
      "minWidth",
      "maxWidth",
      "flex",
      "flexShrink",
      "flexGrow",
      "flexBasis",
      "tableLayout",
      "captionSide",
      "borderCollapse",
      "borderSpacing",
      "transformOrigin",
      "translate",
      "rotate",
      "skew",
      "scale",
      "transform",
      "animation",
      "cursor",
      "touchAction",
      "userSelect",
      "resize",
      "scrollSnapType",
      "scrollSnapAlign",
      "scrollSnapStop",
      "scrollMargin",
      "scrollPadding",
      "listStylePosition",
      "listStyleType",
      "listStyleImage",
      "appearance",
      "columns",
      "breakBefore",
      "breakInside",
      "breakAfter",
      "gridAutoColumns",
      "gridAutoFlow",
      "gridAutoRows",
      "gridTemplateColumns",
      "gridTemplateRows",
      "flexDirection",
      "flexWrap",
      "placeContent",
      "placeItems",
      "alignContent",
      "alignItems",
      "justifyContent",
      "justifyItems",
      "gap",
      "space",
      "divideWidth",
      "divideStyle",
      "divideColor",
      "divideOpacity",
      "placeSelf",
      "alignSelf",
      "justifySelf",
      "overflow",
      "overscrollBehavior",
      "scrollBehavior",
      "textOverflow",
      "hyphens",
      "whitespace",
      "textWrap",
      "wordBreak",
      "borderRadius",
      "borderWidth",
      "borderStyle",
      "borderColor",
      "borderOpacity",
      "backgroundColor",
      "backgroundOpacity",
      "backgroundImage",
      "gradientColorStops",
      "boxDecorationBreak",
      "backgroundSize",
      "backgroundAttachment",
      "backgroundClip",
      "backgroundPosition",
      "backgroundRepeat",
      "backgroundOrigin",
      "fill",
      "stroke",
      "strokeWidth",
      "objectFit",
      "objectPosition",
      "padding",
      "textAlign",
      "textIndent",
      "verticalAlign",
      "fontFamily",
      "fontSize",
      "fontWeight",
      "textTransform",
      "fontStyle",
      "fontVariantNumeric",
      "lineHeight",
      "letterSpacing",
      "textColor",
      "textOpacity",
      "textDecoration",
      "textDecorationColor",
      "textDecorationStyle",
      "textDecorationThickness",
      "textUnderlineOffset",
      "fontSmoothing",
      "placeholderColor",
      "placeholderOpacity",
      "caretColor",
      "accentColor",
      "opacity",
      "backgroundBlendMode",
      "mixBlendMode",
      "boxShadow",
      "boxShadowColor",
      "outlineStyle",
      "outlineWidth",
      "outlineOffset",
      "outlineColor",
      "ringWidth",
      "ringColor",
      "ringOpacity",
      "ringOffsetWidth",
      "ringOffsetColor",
      "blur",
      "brightness",
      "contrast",
      "dropShadow",
      "grayscale",
      "hueRotate",
      "invert",
      "saturate",
      "sepia",
      "filter",
      "backdropBlur",
      "backdropBrightness",
      "backdropContrast",
      "backdropGrayscale",
      "backdropHueRotate",
      "backdropInvert",
      "backdropOpacity",
      "backdropSaturate",
      "backdropSepia",
      "backdropFilter",
      "transitionProperty",
      "transitionDelay",
      "transitionDuration",
      "transitionTimingFunction",
      "willChange",
      "contain",
      "content",
      "forcedColorAdjust"
    ];
  })(xe)), xe;
}
var we = {}, gr;
function It() {
  return gr || (gr = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return u;
      }
    });
    function u(a, o) {
      return a === void 0 ? o : Array.isArray(a) ? a : [
        ...new Set(o.filter((n) => a !== !1 && a[n] !== !1).concat(Object.keys(a).filter((n) => a[n] !== !1)))
      ];
    }
  })(we)), we;
}
var _e = {}, Oe = {}, le = { exports: {} }, vr;
function et() {
  if (vr) return le.exports;
  vr = 1;
  var e = String, u = function() {
    return { isColorSupported: !1, reset: e, bold: e, dim: e, italic: e, underline: e, inverse: e, hidden: e, strikethrough: e, black: e, red: e, green: e, yellow: e, blue: e, magenta: e, cyan: e, white: e, gray: e, bgBlack: e, bgRed: e, bgGreen: e, bgYellow: e, bgBlue: e, bgMagenta: e, bgCyan: e, bgWhite: e, blackBright: e, redBright: e, greenBright: e, yellowBright: e, blueBright: e, magentaBright: e, cyanBright: e, whiteBright: e, bgBlackBright: e, bgRedBright: e, bgGreenBright: e, bgYellowBright: e, bgBlueBright: e, bgMagentaBright: e, bgCyanBright: e, bgWhiteBright: e };
  };
  return le.exports = u(), le.exports.createColors = u, le.exports;
}
var hr;
function Xe() {
  return hr || (hr = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function u(l, t) {
      for (var f in t) Object.defineProperty(l, f, {
        enumerable: !0,
        get: t[f]
      });
    }
    u(e, {
      dim: function() {
        return r;
      },
      default: function() {
        return p;
      }
    });
    const a = /* @__PURE__ */ o(/* @__PURE__ */ et());
    function o(l) {
      return l && l.__esModule ? l : {
        default: l
      };
    }
    let i = /* @__PURE__ */ new Set();
    function n(l, t, f) {
      typeof process < "u" && process.env.JEST_WORKER_ID || f && i.has(f) || (f && i.add(f), console.warn(""), t.forEach((c) => console.warn(l, "-", c)));
    }
    function r(l) {
      return a.default.dim(l);
    }
    const p = {
      info(l, t) {
        n(a.default.bold(a.default.cyan("info")), ...Array.isArray(l) ? [
          l
        ] : [
          t,
          l
        ]);
      },
      warn(l, t) {
        n(a.default.bold(a.default.yellow("warn")), ...Array.isArray(l) ? [
          l
        ] : [
          t,
          l
        ]);
      },
      risk(l, t) {
        n(a.default.bold(a.default.magenta("risk")), ...Array.isArray(l) ? [
          l
        ] : [
          t,
          l
        ]);
      }
    };
  })(Oe)), Oe;
}
var yr;
function Ut() {
  return yr || (yr = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const u = /* @__PURE__ */ a(Xe());
    function a(n) {
      return n && n.__esModule ? n : {
        default: n
      };
    }
    function o({ version: n, from: r, to: p }) {
      u.default.warn(`${r}-color-renamed`, [
        `As of Tailwind CSS ${n}, \`${r}\` has been renamed to \`${p}\`.`,
        "Update your configuration file to silence this warning."
      ]);
    }
    const i = {
      inherit: "inherit",
      current: "currentColor",
      transparent: "transparent",
      black: "#000",
      white: "#fff",
      slate: {
        50: "#f8fafc",
        100: "#f1f5f9",
        200: "#e2e8f0",
        300: "#cbd5e1",
        400: "#94a3b8",
        500: "#64748b",
        600: "#475569",
        700: "#334155",
        800: "#1e293b",
        900: "#0f172a",
        950: "#020617"
      },
      gray: {
        50: "#f9fafb",
        100: "#f3f4f6",
        200: "#e5e7eb",
        300: "#d1d5db",
        400: "#9ca3af",
        500: "#6b7280",
        600: "#4b5563",
        700: "#374151",
        800: "#1f2937",
        900: "#111827",
        950: "#030712"
      },
      zinc: {
        50: "#fafafa",
        100: "#f4f4f5",
        200: "#e4e4e7",
        300: "#d4d4d8",
        400: "#a1a1aa",
        500: "#71717a",
        600: "#52525b",
        700: "#3f3f46",
        800: "#27272a",
        900: "#18181b",
        950: "#09090b"
      },
      neutral: {
        50: "#fafafa",
        100: "#f5f5f5",
        200: "#e5e5e5",
        300: "#d4d4d4",
        400: "#a3a3a3",
        500: "#737373",
        600: "#525252",
        700: "#404040",
        800: "#262626",
        900: "#171717",
        950: "#0a0a0a"
      },
      stone: {
        50: "#fafaf9",
        100: "#f5f5f4",
        200: "#e7e5e4",
        300: "#d6d3d1",
        400: "#a8a29e",
        500: "#78716c",
        600: "#57534e",
        700: "#44403c",
        800: "#292524",
        900: "#1c1917",
        950: "#0c0a09"
      },
      red: {
        50: "#fef2f2",
        100: "#fee2e2",
        200: "#fecaca",
        300: "#fca5a5",
        400: "#f87171",
        500: "#ef4444",
        600: "#dc2626",
        700: "#b91c1c",
        800: "#991b1b",
        900: "#7f1d1d",
        950: "#450a0a"
      },
      orange: {
        50: "#fff7ed",
        100: "#ffedd5",
        200: "#fed7aa",
        300: "#fdba74",
        400: "#fb923c",
        500: "#f97316",
        600: "#ea580c",
        700: "#c2410c",
        800: "#9a3412",
        900: "#7c2d12",
        950: "#431407"
      },
      amber: {
        50: "#fffbeb",
        100: "#fef3c7",
        200: "#fde68a",
        300: "#fcd34d",
        400: "#fbbf24",
        500: "#f59e0b",
        600: "#d97706",
        700: "#b45309",
        800: "#92400e",
        900: "#78350f",
        950: "#451a03"
      },
      yellow: {
        50: "#fefce8",
        100: "#fef9c3",
        200: "#fef08a",
        300: "#fde047",
        400: "#facc15",
        500: "#eab308",
        600: "#ca8a04",
        700: "#a16207",
        800: "#854d0e",
        900: "#713f12",
        950: "#422006"
      },
      lime: {
        50: "#f7fee7",
        100: "#ecfccb",
        200: "#d9f99d",
        300: "#bef264",
        400: "#a3e635",
        500: "#84cc16",
        600: "#65a30d",
        700: "#4d7c0f",
        800: "#3f6212",
        900: "#365314",
        950: "#1a2e05"
      },
      green: {
        50: "#f0fdf4",
        100: "#dcfce7",
        200: "#bbf7d0",
        300: "#86efac",
        400: "#4ade80",
        500: "#22c55e",
        600: "#16a34a",
        700: "#15803d",
        800: "#166534",
        900: "#14532d",
        950: "#052e16"
      },
      emerald: {
        50: "#ecfdf5",
        100: "#d1fae5",
        200: "#a7f3d0",
        300: "#6ee7b7",
        400: "#34d399",
        500: "#10b981",
        600: "#059669",
        700: "#047857",
        800: "#065f46",
        900: "#064e3b",
        950: "#022c22"
      },
      teal: {
        50: "#f0fdfa",
        100: "#ccfbf1",
        200: "#99f6e4",
        300: "#5eead4",
        400: "#2dd4bf",
        500: "#14b8a6",
        600: "#0d9488",
        700: "#0f766e",
        800: "#115e59",
        900: "#134e4a",
        950: "#042f2e"
      },
      cyan: {
        50: "#ecfeff",
        100: "#cffafe",
        200: "#a5f3fc",
        300: "#67e8f9",
        400: "#22d3ee",
        500: "#06b6d4",
        600: "#0891b2",
        700: "#0e7490",
        800: "#155e75",
        900: "#164e63",
        950: "#083344"
      },
      sky: {
        50: "#f0f9ff",
        100: "#e0f2fe",
        200: "#bae6fd",
        300: "#7dd3fc",
        400: "#38bdf8",
        500: "#0ea5e9",
        600: "#0284c7",
        700: "#0369a1",
        800: "#075985",
        900: "#0c4a6e",
        950: "#082f49"
      },
      blue: {
        50: "#eff6ff",
        100: "#dbeafe",
        200: "#bfdbfe",
        300: "#93c5fd",
        400: "#60a5fa",
        500: "#3b82f6",
        600: "#2563eb",
        700: "#1d4ed8",
        800: "#1e40af",
        900: "#1e3a8a",
        950: "#172554"
      },
      indigo: {
        50: "#eef2ff",
        100: "#e0e7ff",
        200: "#c7d2fe",
        300: "#a5b4fc",
        400: "#818cf8",
        500: "#6366f1",
        600: "#4f46e5",
        700: "#4338ca",
        800: "#3730a3",
        900: "#312e81",
        950: "#1e1b4b"
      },
      violet: {
        50: "#f5f3ff",
        100: "#ede9fe",
        200: "#ddd6fe",
        300: "#c4b5fd",
        400: "#a78bfa",
        500: "#8b5cf6",
        600: "#7c3aed",
        700: "#6d28d9",
        800: "#5b21b6",
        900: "#4c1d95",
        950: "#2e1065"
      },
      purple: {
        50: "#faf5ff",
        100: "#f3e8ff",
        200: "#e9d5ff",
        300: "#d8b4fe",
        400: "#c084fc",
        500: "#a855f7",
        600: "#9333ea",
        700: "#7e22ce",
        800: "#6b21a8",
        900: "#581c87",
        950: "#3b0764"
      },
      fuchsia: {
        50: "#fdf4ff",
        100: "#fae8ff",
        200: "#f5d0fe",
        300: "#f0abfc",
        400: "#e879f9",
        500: "#d946ef",
        600: "#c026d3",
        700: "#a21caf",
        800: "#86198f",
        900: "#701a75",
        950: "#4a044e"
      },
      pink: {
        50: "#fdf2f8",
        100: "#fce7f3",
        200: "#fbcfe8",
        300: "#f9a8d4",
        400: "#f472b6",
        500: "#ec4899",
        600: "#db2777",
        700: "#be185d",
        800: "#9d174d",
        900: "#831843",
        950: "#500724"
      },
      rose: {
        50: "#fff1f2",
        100: "#ffe4e6",
        200: "#fecdd3",
        300: "#fda4af",
        400: "#fb7185",
        500: "#f43f5e",
        600: "#e11d48",
        700: "#be123c",
        800: "#9f1239",
        900: "#881337",
        950: "#4c0519"
      },
      get lightBlue() {
        return o({
          version: "v2.2",
          from: "lightBlue",
          to: "sky"
        }), this.sky;
      },
      get warmGray() {
        return o({
          version: "v3.0",
          from: "warmGray",
          to: "stone"
        }), this.stone;
      },
      get trueGray() {
        return o({
          version: "v3.0",
          from: "trueGray",
          to: "neutral"
        }), this.neutral;
      },
      get coolGray() {
        return o({
          version: "v3.0",
          from: "coolGray",
          to: "gray"
        }), this.gray;
      },
      get blueGray() {
        return o({
          version: "v3.0",
          from: "blueGray",
          to: "slate"
        }), this.slate;
      }
    };
  })(_e)), _e;
}
var Ee = {}, br;
function Wt() {
  return br || (br = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "defaults", {
      enumerable: !0,
      get: function() {
        return u;
      }
    });
    function u(a, ...o) {
      for (let r of o) {
        for (let p in r) {
          var i;
          !(a == null || (i = a.hasOwnProperty) === null || i === void 0) && i.call(a, p) || (a[p] = r[p]);
        }
        for (let p of Object.getOwnPropertySymbols(r)) {
          var n;
          !(a == null || (n = a.hasOwnProperty) === null || n === void 0) && n.call(a, p) || (a[p] = r[p]);
        }
      }
      return a;
    }
  })(Ee)), Ee;
}
var Te = {}, xr;
function Bt() {
  return xr || (xr = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "toPath", {
      enumerable: !0,
      get: function() {
        return u;
      }
    });
    function u(a) {
      if (Array.isArray(a)) return a;
      let o = a.split("[").length - 1, i = a.split("]").length - 1;
      if (o !== i)
        throw new Error(`Path is invalid. Has unbalanced brackets: ${a}`);
      return a.split(/\.(?![^\[]*\])|[\[\]]/g).filter(Boolean);
    }
  })(Te)), Te;
}
var Ce = {}, Ae = {}, wr;
function Ke() {
  return wr || (wr = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function u(c, d) {
      for (var v in d) Object.defineProperty(c, v, {
        enumerable: !0,
        get: d[v]
      });
    }
    u(e, {
      flagEnabled: function() {
        return p;
      },
      issueFlagNotices: function() {
        return t;
      },
      default: function() {
        return f;
      }
    });
    const a = /* @__PURE__ */ i(/* @__PURE__ */ et()), o = /* @__PURE__ */ i(Xe());
    function i(c) {
      return c && c.__esModule ? c : {
        default: c
      };
    }
    let n = {
      optimizeUniversalDefaults: !1,
      generalizedModifiers: !0,
      disableColorOpacityUtilitiesByDefault: !1,
      relativeContentPathsByDefault: !1
    }, r = {
      future: [
        "hoverOnlyWhenSupported",
        "respectDefaultRingColorOpacity",
        "disableColorOpacityUtilitiesByDefault",
        "relativeContentPathsByDefault"
      ],
      experimental: [
        "optimizeUniversalDefaults",
        "generalizedModifiers"
      ]
    };
    function p(c, d) {
      if (r.future.includes(d)) {
        var v, h, O;
        return c.future === "all" || ((O = (h = c == null || (v = c.future) === null || v === void 0 ? void 0 : v[d]) !== null && h !== void 0 ? h : n[d]) !== null && O !== void 0 ? O : !1);
      }
      if (r.experimental.includes(d)) {
        var P, q, U;
        return c.experimental === "all" || ((U = (q = c == null || (P = c.experimental) === null || P === void 0 ? void 0 : P[d]) !== null && q !== void 0 ? q : n[d]) !== null && U !== void 0 ? U : !1);
      }
      return !1;
    }
    function l(c) {
      if (c.experimental === "all")
        return r.experimental;
      var d;
      return Object.keys((d = c?.experimental) !== null && d !== void 0 ? d : {}).filter((v) => r.experimental.includes(v) && c.experimental[v]);
    }
    function t(c) {
      if (process.env.JEST_WORKER_ID === void 0 && l(c).length > 0) {
        let d = l(c).map((v) => a.default.yellow(v)).join(", ");
        o.default.warn("experimental-flags-enabled", [
          `You have enabled experimental features: ${d}`,
          "Experimental features in Tailwind CSS are not covered by semver, may introduce breaking changes, and can change at any time."
        ]);
      }
    }
    const f = r;
  })(Ae)), Ae;
}
var _r;
function Nt() {
  return _r || (_r = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "normalizeConfig", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const u = Ke(), a = /* @__PURE__ */ i(Xe());
    function o(r) {
      if (typeof WeakMap != "function") return null;
      var p = /* @__PURE__ */ new WeakMap(), l = /* @__PURE__ */ new WeakMap();
      return (o = function(t) {
        return t ? l : p;
      })(r);
    }
    function i(r, p) {
      if (r && r.__esModule)
        return r;
      if (r === null || typeof r != "object" && typeof r != "function")
        return {
          default: r
        };
      var l = o(p);
      if (l && l.has(r))
        return l.get(r);
      var t = {}, f = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var c in r)
        if (c !== "default" && Object.prototype.hasOwnProperty.call(r, c)) {
          var d = f ? Object.getOwnPropertyDescriptor(r, c) : null;
          d && (d.get || d.set) ? Object.defineProperty(t, c, d) : t[c] = r[c];
        }
      return t.default = r, l && l.set(r, t), t;
    }
    function n(r) {
      if ((() => {
        if (r.purge || !r.content || !Array.isArray(r.content) && !(typeof r.content == "object" && r.content !== null))
          return !1;
        if (Array.isArray(r.content))
          return r.content.every((t) => typeof t == "string" ? !0 : !(typeof t?.raw != "string" || t?.extension && typeof t?.extension != "string"));
        if (typeof r.content == "object" && r.content !== null) {
          if (Object.keys(r.content).some((t) => ![
            "files",
            "relative",
            "extract",
            "transform"
          ].includes(t)))
            return !1;
          if (Array.isArray(r.content.files)) {
            if (!r.content.files.every((t) => typeof t == "string" ? !0 : !(typeof t?.raw != "string" || t?.extension && typeof t?.extension != "string")))
              return !1;
            if (typeof r.content.extract == "object") {
              for (let t of Object.values(r.content.extract))
                if (typeof t != "function")
                  return !1;
            } else if (!(r.content.extract === void 0 || typeof r.content.extract == "function"))
              return !1;
            if (typeof r.content.transform == "object") {
              for (let t of Object.values(r.content.transform))
                if (typeof t != "function")
                  return !1;
            } else if (!(r.content.transform === void 0 || typeof r.content.transform == "function"))
              return !1;
            if (typeof r.content.relative != "boolean" && typeof r.content.relative < "u")
              return !1;
          }
          return !0;
        }
        return !1;
      })() || a.default.warn("purge-deprecation", [
        "The `purge`/`content` options have changed in Tailwind CSS v3.0.",
        "Update your configuration file to eliminate this warning.",
        "https://tailwindcss.com/docs/upgrade-guide#configure-content-sources"
      ]), r.safelist = (() => {
        var t;
        let { content: f, purge: c, safelist: d } = r;
        return Array.isArray(d) ? d : Array.isArray(f?.safelist) ? f.safelist : Array.isArray(c?.safelist) ? c.safelist : Array.isArray(c == null || (t = c.options) === null || t === void 0 ? void 0 : t.safelist) ? c.options.safelist : [];
      })(), r.blocklist = (() => {
        let { blocklist: t } = r;
        if (Array.isArray(t)) {
          if (t.every((f) => typeof f == "string"))
            return t;
          a.default.warn("blocklist-invalid", [
            "The `blocklist` option must be an array of strings.",
            "https://tailwindcss.com/docs/content-configuration#discarding-classes"
          ]);
        }
        return [];
      })(), typeof r.prefix == "function")
        a.default.warn("prefix-function", [
          "As of Tailwind CSS v3.0, `prefix` cannot be a function.",
          "Update `prefix` in your configuration to be a string to eliminate this warning.",
          "https://tailwindcss.com/docs/upgrade-guide#prefix-cannot-be-a-function"
        ]), r.prefix = "";
      else {
        var l;
        r.prefix = (l = r.prefix) !== null && l !== void 0 ? l : "";
      }
      r.content = {
        relative: (() => {
          let { content: t } = r;
          return t?.relative ? t.relative : (0, u.flagEnabled)(r, "relativeContentPathsByDefault");
        })(),
        files: (() => {
          let { content: t, purge: f } = r;
          return Array.isArray(f) ? f : Array.isArray(f?.content) ? f.content : Array.isArray(t) ? t : Array.isArray(t?.content) ? t.content : Array.isArray(t?.files) ? t.files : [];
        })(),
        extract: (() => {
          let t = (() => {
            var d, v, h, O, P, q, U, k, M, y;
            return !((d = r.purge) === null || d === void 0) && d.extract ? r.purge.extract : !((v = r.content) === null || v === void 0) && v.extract ? r.content.extract : !((h = r.purge) === null || h === void 0 || (O = h.extract) === null || O === void 0) && O.DEFAULT ? r.purge.extract.DEFAULT : !((P = r.content) === null || P === void 0 || (q = P.extract) === null || q === void 0) && q.DEFAULT ? r.content.extract.DEFAULT : !((U = r.purge) === null || U === void 0 || (k = U.options) === null || k === void 0) && k.extractors ? r.purge.options.extractors : !((M = r.content) === null || M === void 0 || (y = M.options) === null || y === void 0) && y.extractors ? r.content.options.extractors : {};
          })(), f = {}, c = (() => {
            var d, v, h, O;
            if (!((d = r.purge) === null || d === void 0 || (v = d.options) === null || v === void 0) && v.defaultExtractor)
              return r.purge.options.defaultExtractor;
            if (!((h = r.content) === null || h === void 0 || (O = h.options) === null || O === void 0) && O.defaultExtractor)
              return r.content.options.defaultExtractor;
          })();
          if (c !== void 0 && (f.DEFAULT = c), typeof t == "function")
            f.DEFAULT = t;
          else if (Array.isArray(t))
            for (let { extensions: d, extractor: v } of t ?? [])
              for (let h of d)
                f[h] = v;
          else typeof t == "object" && t !== null && Object.assign(f, t);
          return f;
        })(),
        transform: (() => {
          let t = (() => {
            var c, d, v, h, O, P;
            return !((c = r.purge) === null || c === void 0) && c.transform ? r.purge.transform : !((d = r.content) === null || d === void 0) && d.transform ? r.content.transform : !((v = r.purge) === null || v === void 0 || (h = v.transform) === null || h === void 0) && h.DEFAULT ? r.purge.transform.DEFAULT : !((O = r.content) === null || O === void 0 || (P = O.transform) === null || P === void 0) && P.DEFAULT ? r.content.transform.DEFAULT : {};
          })(), f = {};
          return typeof t == "function" ? f.DEFAULT = t : typeof t == "object" && t !== null && Object.assign(f, t), f;
        })()
      };
      for (let t of r.content.files)
        if (typeof t == "string" && /{([^,]*?)}/g.test(t)) {
          a.default.warn("invalid-glob-braces", [
            `The glob pattern ${(0, a.dim)(t)} in your Tailwind CSS configuration is invalid.`,
            `Update it to ${(0, a.dim)(t.replace(/{([^,]*?)}/g, "$1"))} to silence this warning.`
          ]);
          break;
        }
      return r;
    }
  })(Ce)), Ce;
}
var ke = {}, Or;
function Vt() {
  return Or || (Or = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return u;
      }
    });
    function u(a) {
      if (Object.prototype.toString.call(a) !== "[object Object]")
        return !1;
      const o = Object.getPrototypeOf(a);
      return o === null || Object.getPrototypeOf(o) === null;
    }
  })(ke)), ke;
}
var Pe = {}, Er;
function Ht() {
  return Er || (Er = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "cloneDeep", {
      enumerable: !0,
      get: function() {
        return u;
      }
    });
    function u(a) {
      return Array.isArray(a) ? a.map((o) => u(o)) : typeof a == "object" && a !== null ? Object.fromEntries(Object.entries(a).map(([o, i]) => [
        o,
        u(i)
      ])) : a;
    }
  })(Pe)), Pe;
}
var Se = {}, Re = {}, Tr;
function Yt() {
  return Tr || (Tr = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return u;
      }
    });
    function u(a) {
      return a.replace(/\\,/g, "\\2c ");
    }
  })(Re)), Re;
}
var Me = {}, De = {}, qe = {}, Cr;
function Gt() {
  return Cr || (Cr = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return u;
      }
    });
    const u = {
      aliceblue: [
        240,
        248,
        255
      ],
      antiquewhite: [
        250,
        235,
        215
      ],
      aqua: [
        0,
        255,
        255
      ],
      aquamarine: [
        127,
        255,
        212
      ],
      azure: [
        240,
        255,
        255
      ],
      beige: [
        245,
        245,
        220
      ],
      bisque: [
        255,
        228,
        196
      ],
      black: [
        0,
        0,
        0
      ],
      blanchedalmond: [
        255,
        235,
        205
      ],
      blue: [
        0,
        0,
        255
      ],
      blueviolet: [
        138,
        43,
        226
      ],
      brown: [
        165,
        42,
        42
      ],
      burlywood: [
        222,
        184,
        135
      ],
      cadetblue: [
        95,
        158,
        160
      ],
      chartreuse: [
        127,
        255,
        0
      ],
      chocolate: [
        210,
        105,
        30
      ],
      coral: [
        255,
        127,
        80
      ],
      cornflowerblue: [
        100,
        149,
        237
      ],
      cornsilk: [
        255,
        248,
        220
      ],
      crimson: [
        220,
        20,
        60
      ],
      cyan: [
        0,
        255,
        255
      ],
      darkblue: [
        0,
        0,
        139
      ],
      darkcyan: [
        0,
        139,
        139
      ],
      darkgoldenrod: [
        184,
        134,
        11
      ],
      darkgray: [
        169,
        169,
        169
      ],
      darkgreen: [
        0,
        100,
        0
      ],
      darkgrey: [
        169,
        169,
        169
      ],
      darkkhaki: [
        189,
        183,
        107
      ],
      darkmagenta: [
        139,
        0,
        139
      ],
      darkolivegreen: [
        85,
        107,
        47
      ],
      darkorange: [
        255,
        140,
        0
      ],
      darkorchid: [
        153,
        50,
        204
      ],
      darkred: [
        139,
        0,
        0
      ],
      darksalmon: [
        233,
        150,
        122
      ],
      darkseagreen: [
        143,
        188,
        143
      ],
      darkslateblue: [
        72,
        61,
        139
      ],
      darkslategray: [
        47,
        79,
        79
      ],
      darkslategrey: [
        47,
        79,
        79
      ],
      darkturquoise: [
        0,
        206,
        209
      ],
      darkviolet: [
        148,
        0,
        211
      ],
      deeppink: [
        255,
        20,
        147
      ],
      deepskyblue: [
        0,
        191,
        255
      ],
      dimgray: [
        105,
        105,
        105
      ],
      dimgrey: [
        105,
        105,
        105
      ],
      dodgerblue: [
        30,
        144,
        255
      ],
      firebrick: [
        178,
        34,
        34
      ],
      floralwhite: [
        255,
        250,
        240
      ],
      forestgreen: [
        34,
        139,
        34
      ],
      fuchsia: [
        255,
        0,
        255
      ],
      gainsboro: [
        220,
        220,
        220
      ],
      ghostwhite: [
        248,
        248,
        255
      ],
      gold: [
        255,
        215,
        0
      ],
      goldenrod: [
        218,
        165,
        32
      ],
      gray: [
        128,
        128,
        128
      ],
      green: [
        0,
        128,
        0
      ],
      greenyellow: [
        173,
        255,
        47
      ],
      grey: [
        128,
        128,
        128
      ],
      honeydew: [
        240,
        255,
        240
      ],
      hotpink: [
        255,
        105,
        180
      ],
      indianred: [
        205,
        92,
        92
      ],
      indigo: [
        75,
        0,
        130
      ],
      ivory: [
        255,
        255,
        240
      ],
      khaki: [
        240,
        230,
        140
      ],
      lavender: [
        230,
        230,
        250
      ],
      lavenderblush: [
        255,
        240,
        245
      ],
      lawngreen: [
        124,
        252,
        0
      ],
      lemonchiffon: [
        255,
        250,
        205
      ],
      lightblue: [
        173,
        216,
        230
      ],
      lightcoral: [
        240,
        128,
        128
      ],
      lightcyan: [
        224,
        255,
        255
      ],
      lightgoldenrodyellow: [
        250,
        250,
        210
      ],
      lightgray: [
        211,
        211,
        211
      ],
      lightgreen: [
        144,
        238,
        144
      ],
      lightgrey: [
        211,
        211,
        211
      ],
      lightpink: [
        255,
        182,
        193
      ],
      lightsalmon: [
        255,
        160,
        122
      ],
      lightseagreen: [
        32,
        178,
        170
      ],
      lightskyblue: [
        135,
        206,
        250
      ],
      lightslategray: [
        119,
        136,
        153
      ],
      lightslategrey: [
        119,
        136,
        153
      ],
      lightsteelblue: [
        176,
        196,
        222
      ],
      lightyellow: [
        255,
        255,
        224
      ],
      lime: [
        0,
        255,
        0
      ],
      limegreen: [
        50,
        205,
        50
      ],
      linen: [
        250,
        240,
        230
      ],
      magenta: [
        255,
        0,
        255
      ],
      maroon: [
        128,
        0,
        0
      ],
      mediumaquamarine: [
        102,
        205,
        170
      ],
      mediumblue: [
        0,
        0,
        205
      ],
      mediumorchid: [
        186,
        85,
        211
      ],
      mediumpurple: [
        147,
        112,
        219
      ],
      mediumseagreen: [
        60,
        179,
        113
      ],
      mediumslateblue: [
        123,
        104,
        238
      ],
      mediumspringgreen: [
        0,
        250,
        154
      ],
      mediumturquoise: [
        72,
        209,
        204
      ],
      mediumvioletred: [
        199,
        21,
        133
      ],
      midnightblue: [
        25,
        25,
        112
      ],
      mintcream: [
        245,
        255,
        250
      ],
      mistyrose: [
        255,
        228,
        225
      ],
      moccasin: [
        255,
        228,
        181
      ],
      navajowhite: [
        255,
        222,
        173
      ],
      navy: [
        0,
        0,
        128
      ],
      oldlace: [
        253,
        245,
        230
      ],
      olive: [
        128,
        128,
        0
      ],
      olivedrab: [
        107,
        142,
        35
      ],
      orange: [
        255,
        165,
        0
      ],
      orangered: [
        255,
        69,
        0
      ],
      orchid: [
        218,
        112,
        214
      ],
      palegoldenrod: [
        238,
        232,
        170
      ],
      palegreen: [
        152,
        251,
        152
      ],
      paleturquoise: [
        175,
        238,
        238
      ],
      palevioletred: [
        219,
        112,
        147
      ],
      papayawhip: [
        255,
        239,
        213
      ],
      peachpuff: [
        255,
        218,
        185
      ],
      peru: [
        205,
        133,
        63
      ],
      pink: [
        255,
        192,
        203
      ],
      plum: [
        221,
        160,
        221
      ],
      powderblue: [
        176,
        224,
        230
      ],
      purple: [
        128,
        0,
        128
      ],
      rebeccapurple: [
        102,
        51,
        153
      ],
      red: [
        255,
        0,
        0
      ],
      rosybrown: [
        188,
        143,
        143
      ],
      royalblue: [
        65,
        105,
        225
      ],
      saddlebrown: [
        139,
        69,
        19
      ],
      salmon: [
        250,
        128,
        114
      ],
      sandybrown: [
        244,
        164,
        96
      ],
      seagreen: [
        46,
        139,
        87
      ],
      seashell: [
        255,
        245,
        238
      ],
      sienna: [
        160,
        82,
        45
      ],
      silver: [
        192,
        192,
        192
      ],
      skyblue: [
        135,
        206,
        235
      ],
      slateblue: [
        106,
        90,
        205
      ],
      slategray: [
        112,
        128,
        144
      ],
      slategrey: [
        112,
        128,
        144
      ],
      snow: [
        255,
        250,
        250
      ],
      springgreen: [
        0,
        255,
        127
      ],
      steelblue: [
        70,
        130,
        180
      ],
      tan: [
        210,
        180,
        140
      ],
      teal: [
        0,
        128,
        128
      ],
      thistle: [
        216,
        191,
        216
      ],
      tomato: [
        255,
        99,
        71
      ],
      turquoise: [
        64,
        224,
        208
      ],
      violet: [
        238,
        130,
        238
      ],
      wheat: [
        245,
        222,
        179
      ],
      white: [
        255,
        255,
        255
      ],
      whitesmoke: [
        245,
        245,
        245
      ],
      yellow: [
        255,
        255,
        0
      ],
      yellowgreen: [
        154,
        205,
        50
      ]
    };
  })(qe)), qe;
}
var Ar;
function rt() {
  return Ar || (Ar = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function u(h, O) {
      for (var P in O) Object.defineProperty(h, P, {
        enumerable: !0,
        get: O[P]
      });
    }
    u(e, {
      parseColor: function() {
        return d;
      },
      formatColor: function() {
        return v;
      }
    });
    const a = /* @__PURE__ */ o(Gt());
    function o(h) {
      return h && h.__esModule ? h : {
        default: h
      };
    }
    let i = /^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i, n = /^#([a-f\d])([a-f\d])([a-f\d])([a-f\d])?$/i, r = /(?:\d+|\d*\.\d+)%?/, p = /(?:\s*,\s*|\s+)/, l = /\s*[,/]\s*/, t = /var\(--(?:[^ )]*?)(?:,(?:[^ )]*?|var\(--[^ )]*?\)))?\)/, f = new RegExp(`^(rgba?)\\(\\s*(${r.source}|${t.source})(?:${p.source}(${r.source}|${t.source}))?(?:${p.source}(${r.source}|${t.source}))?(?:${l.source}(${r.source}|${t.source}))?\\s*\\)$`), c = new RegExp(`^(hsla?)\\(\\s*((?:${r.source})(?:deg|rad|grad|turn)?|${t.source})(?:${p.source}(${r.source}|${t.source}))?(?:${p.source}(${r.source}|${t.source}))?(?:${l.source}(${r.source}|${t.source}))?\\s*\\)$`);
    function d(h, { loose: O = !1 } = {}) {
      var P, q;
      if (typeof h != "string")
        return null;
      if (h = h.trim(), h === "transparent")
        return {
          mode: "rgb",
          color: [
            "0",
            "0",
            "0"
          ],
          alpha: "0"
        };
      if (h in a.default)
        return {
          mode: "rgb",
          color: a.default[h].map((D) => D.toString())
        };
      let U = h.replace(n, (D, W, K, x, S) => [
        "#",
        W,
        W,
        K,
        K,
        x,
        x,
        S ? S + S : ""
      ].join("")).match(i);
      if (U !== null)
        return {
          mode: "rgb",
          color: [
            parseInt(U[1], 16),
            parseInt(U[2], 16),
            parseInt(U[3], 16)
          ].map((D) => D.toString()),
          alpha: U[4] ? (parseInt(U[4], 16) / 255).toString() : void 0
        };
      var k;
      let M = (k = h.match(f)) !== null && k !== void 0 ? k : h.match(c);
      if (M === null)
        return null;
      let y = [
        M[2],
        M[3],
        M[4]
      ].filter(Boolean).map((D) => D.toString());
      return y.length === 2 && y[0].startsWith("var(") ? {
        mode: M[1],
        color: [
          y[0]
        ],
        alpha: y[1]
      } : !O && y.length !== 3 || y.length < 3 && !y.some((D) => /^var\(.*?\)$/.test(D)) ? null : {
        mode: M[1],
        color: y,
        alpha: (P = M[5]) === null || P === void 0 || (q = P.toString) === null || q === void 0 ? void 0 : q.call(P)
      };
    }
    function v({ mode: h, color: O, alpha: P }) {
      let q = P !== void 0;
      return h === "rgba" || h === "hsla" ? `${h}(${O.join(", ")}${q ? `, ${P}` : ""})` : `${h}(${O.join(" ")}${q ? ` / ${P}` : ""})`;
    }
  })(De)), De;
}
var kr;
function tt() {
  return kr || (kr = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function u(n, r) {
      for (var p in r) Object.defineProperty(n, p, {
        enumerable: !0,
        get: r[p]
      });
    }
    u(e, {
      withAlphaValue: function() {
        return o;
      },
      default: function() {
        return i;
      }
    });
    const a = rt();
    function o(n, r, p) {
      if (typeof n == "function")
        return n({
          opacityValue: r
        });
      let l = (0, a.parseColor)(n, {
        loose: !0
      });
      return l === null ? p : (0, a.formatColor)({
        ...l,
        alpha: r
      });
    }
    function i({ color: n, property: r, variable: p }) {
      let l = [].concat(r);
      if (typeof n == "function")
        return {
          [p]: "1",
          ...Object.fromEntries(l.map((f) => [
            f,
            n({
              opacityVariable: p,
              opacityValue: `var(${p}, 1)`
            })
          ]))
        };
      const t = (0, a.parseColor)(n);
      return t === null ? Object.fromEntries(l.map((f) => [
        f,
        n
      ])) : t.alpha !== void 0 ? Object.fromEntries(l.map((f) => [
        f,
        n
      ])) : {
        [p]: "1",
        ...Object.fromEntries(l.map((f) => [
          f,
          (0, a.formatColor)({
            ...t,
            alpha: `var(${p}, 1)`
          })
        ]))
      };
    }
  })(Me)), Me;
}
var $e = {}, Le = {}, Pr;
function Xt() {
  return Pr || (Pr = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function u(D, W) {
      for (var K in W) Object.defineProperty(D, K, {
        enumerable: !0,
        get: W[K]
      });
    }
    u(e, {
      hasMathFn: function() {
        return M;
      },
      addWhitespaceAroundMathOperators: function() {
        return y;
      }
    });
    const a = 97, o = 122, i = 65, n = 90, r = 101, p = 69, l = 48, t = 57, f = 43, c = 45, d = 42, v = 47, h = 40, O = 41, P = 44, q = 32, U = 37, k = [
      "calc",
      "min",
      "max",
      "clamp",
      "mod",
      "rem",
      "sin",
      "cos",
      "tan",
      "asin",
      "acos",
      "atan",
      "atan2",
      "pow",
      "sqrt",
      "hypot",
      "log",
      "exp",
      "round"
    ];
    function M(D) {
      return D.indexOf("(") !== -1 && k.some((W) => D.includes(`${W}(`));
    }
    function y(D) {
      if (!k.some((w) => D.includes(w)))
        return D;
      let W = "", K = [], x = null, S = null;
      for (let w = 0; w < D.length; w++) {
        let m = D.charCodeAt(w);
        if (m >= l && m <= t || x !== null && (m === U || m >= a && m <= o || m >= i && m <= n) ? x = w : (S = x, x = null), m === h) {
          W += D[w];
          let E = w;
          for (let b = w - 1; b >= 0; b--) {
            let T = D.charCodeAt(b);
            if (T >= l && T <= t)
              E = b;
            else if (T >= a && T <= o)
              E = b;
            else
              break;
          }
          let _ = D.slice(E, w);
          if (k.includes(_)) {
            K.unshift(!0);
            continue;
          } else if (K[0] && _ === "") {
            K.unshift(!0);
            continue;
          }
          K.unshift(!1);
          continue;
        } else if (m === O)
          W += D[w], K.shift();
        else if (m === P && K[0]) {
          W += ", ";
          continue;
        } else {
          if (m === q && K[0] && W.charCodeAt(W.length - 1) === q)
            continue;
          if ((m === f || m === d || m === v || m === c) && K[0]) {
            let E = W.trimEnd(), _ = E.charCodeAt(E.length - 1), b = E.charCodeAt(E.length - 2), T = D.charCodeAt(w + 1);
            if ((_ === r || _ === p) && b >= l && b <= t) {
              W += D[w];
              continue;
            } else if (_ === f || _ === d || _ === v || _ === c) {
              W += D[w];
              continue;
            } else if (_ === h || _ === P) {
              W += D[w];
              continue;
            } else D.charCodeAt(w - 1) === q ? W += `${D[w]} ` : /* Previous is a digit */ _ >= l && _ <= t || // Next is a digit
            T >= l && T <= t || // Previous is end of a function call (or parenthesized expression)
            _ === O || // Next is start of a parenthesized expression
            T === h || // Next is an operator
            T === f || T === d || T === v || T === c || // Previous position was a value (+ unit)
            S !== null && S === w - 1 ? W += ` ${D[w]} ` : W += D[w];
          } else
            W += D[w];
        }
      }
      return W;
    }
  })(Le)), Le;
}
var je = {}, Fe = {}, Sr;
function Qe() {
  return Sr || (Sr = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "splitAtTopLevelOnly", {
      enumerable: !0,
      get: function() {
        return u;
      }
    });
    function u(a, o) {
      let i = [], n = [], r = 0, p = !1;
      for (let l = 0; l < a.length; l++) {
        let t = a[l];
        i.length === 0 && t === o[0] && !p && (o.length === 1 || a.slice(l, l + o.length) === o) && (n.push(a.slice(r, l)), r = l + o.length), p = p ? !1 : t === "\\", t === "(" || t === "[" || t === "{" ? i.push(t) : (t === ")" && i[i.length - 1] === "(" || t === "]" && i[i.length - 1] === "[" || t === "}" && i[i.length - 1] === "{") && i.pop();
      }
      return n.push(a.slice(r)), n;
    }
  })(Fe)), Fe;
}
var Rr;
function Kt() {
  return Rr || (Rr = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function u(l, t) {
      for (var f in t) Object.defineProperty(l, f, {
        enumerable: !0,
        get: t[f]
      });
    }
    u(e, {
      parseBoxShadowValue: function() {
        return r;
      },
      formatBoxShadowValue: function() {
        return p;
      }
    });
    const a = Qe();
    let o = /* @__PURE__ */ new Set([
      "inset",
      "inherit",
      "initial",
      "revert",
      "unset"
    ]), i = /\ +(?![^(]*\))/g, n = /^-?(\d+|\.\d+)(.*?)$/g;
    function r(l) {
      return (0, a.splitAtTopLevelOnly)(l, ",").map((f) => {
        let c = f.trim(), d = {
          raw: c
        }, v = c.split(i), h = /* @__PURE__ */ new Set();
        for (let O of v)
          n.lastIndex = 0, !h.has("KEYWORD") && o.has(O) ? (d.keyword = O, h.add("KEYWORD")) : n.test(O) ? h.has("X") ? h.has("Y") ? h.has("BLUR") ? h.has("SPREAD") || (d.spread = O, h.add("SPREAD")) : (d.blur = O, h.add("BLUR")) : (d.y = O, h.add("Y")) : (d.x = O, h.add("X")) : d.color ? (d.unknown || (d.unknown = []), d.unknown.push(O)) : d.color = O;
        return d.valid = d.x !== void 0 && d.y !== void 0, d;
      });
    }
    function p(l) {
      return l.map((t) => t.valid ? [
        t.keyword,
        t.x,
        t.y,
        t.blur,
        t.spread,
        t.color
      ].filter(Boolean).join(" ") : t.raw).join(", ");
    }
  })(je)), je;
}
var Mr;
function nt() {
  return Mr || (Mr = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function u(g, R) {
      for (var $ in R) Object.defineProperty(g, $, {
        enumerable: !0,
        get: R[$]
      });
    }
    u(e, {
      normalize: function() {
        return t;
      },
      normalizeAttributeSelectors: function() {
        return f;
      },
      url: function() {
        return c;
      },
      number: function() {
        return d;
      },
      percentage: function() {
        return v;
      },
      length: function() {
        return P;
      },
      lineWidth: function() {
        return U;
      },
      shadow: function() {
        return k;
      },
      color: function() {
        return M;
      },
      image: function() {
        return y;
      },
      gradient: function() {
        return W;
      },
      position: function() {
        return x;
      },
      familyName: function() {
        return S;
      },
      genericName: function() {
        return m;
      },
      absoluteSize: function() {
        return _;
      },
      relativeSize: function() {
        return T;
      }
    });
    const a = rt(), o = Xt(), i = Kt(), n = Qe();
    let r = [
      "min",
      "max",
      "clamp",
      "calc"
    ];
    function p(g) {
      return r.some((R) => new RegExp(`^${R}\\(.*\\)`).test(g));
    }
    const l = /* @__PURE__ */ new Set([
      // Concrete properties
      "scroll-timeline-name",
      "timeline-scope",
      "view-timeline-name",
      "font-palette",
      "anchor-name",
      "anchor-scope",
      "position-anchor",
      "position-try-options",
      // Shorthand properties
      "scroll-timeline",
      "animation-timeline",
      "view-timeline",
      "position-try"
    ]);
    function t(g, R = null, $ = !0) {
      let s = R && l.has(R.property);
      return g.startsWith("--") && !s ? `var(${g})` : g.includes("url(") ? g.split(/(url\(.*?\))/g).filter(Boolean).map((C) => /^url\(.*?\)$/.test(C) ? C : t(C, R, !1)).join("") : (g = g.replace(/([^\\])_+/g, (C, j) => j + " ".repeat(C.length - 1)).replace(/^_/g, " ").replace(/\\_/g, "_"), $ && (g = g.trim()), g = (0, o.addWhitespaceAroundMathOperators)(g), g);
    }
    function f(g) {
      return g.includes("=") && (g = g.replace(/(=.*)/g, (R, $) => {
        if ($[1] === "'" || $[1] === '"')
          return $;
        if ($.length > 2) {
          let s = $[$.length - 1];
          if ($[$.length - 2] === " " && (s === "i" || s === "I" || s === "s" || s === "S"))
            return `="${$.slice(1, -2)}" ${$[$.length - 1]}`;
        }
        return `="${$.slice(1)}"`;
      })), g;
    }
    function c(g) {
      return g.startsWith("url(");
    }
    function d(g) {
      return !isNaN(Number(g)) || p(g);
    }
    function v(g) {
      return g.endsWith("%") && d(g.slice(0, -1)) || p(g);
    }
    let O = `(?:${[
      "cm",
      "mm",
      "Q",
      "in",
      "pc",
      "pt",
      "px",
      "em",
      "ex",
      "ch",
      "rem",
      "lh",
      "rlh",
      "vw",
      "vh",
      "vmin",
      "vmax",
      "vb",
      "vi",
      "svw",
      "svh",
      "lvw",
      "lvh",
      "dvw",
      "dvh",
      "cqw",
      "cqh",
      "cqi",
      "cqb",
      "cqmin",
      "cqmax"
    ].join("|")})`;
    function P(g) {
      return g === "0" || new RegExp(`^[+-]?[0-9]*.?[0-9]+(?:[eE][+-]?[0-9]+)?${O}$`).test(g) || p(g);
    }
    let q = /* @__PURE__ */ new Set([
      "thin",
      "medium",
      "thick"
    ]);
    function U(g) {
      return q.has(g);
    }
    function k(g) {
      let R = (0, i.parseBoxShadowValue)(t(g));
      for (let $ of R)
        if (!$.valid)
          return !1;
      return !0;
    }
    function M(g) {
      let R = 0;
      return (0, n.splitAtTopLevelOnly)(g, "_").every((s) => (s = t(s), s.startsWith("var(") ? !0 : (0, a.parseColor)(s, {
        loose: !0
      }) !== null ? (R++, !0) : !1)) ? R > 0 : !1;
    }
    function y(g) {
      let R = 0;
      return (0, n.splitAtTopLevelOnly)(g, ",").every((s) => (s = t(s), s.startsWith("var(") ? !0 : c(s) || W(s) || [
        "element(",
        "image(",
        "cross-fade(",
        "image-set("
      ].some((C) => s.startsWith(C)) ? (R++, !0) : !1)) ? R > 0 : !1;
    }
    let D = /* @__PURE__ */ new Set([
      "conic-gradient",
      "linear-gradient",
      "radial-gradient",
      "repeating-conic-gradient",
      "repeating-linear-gradient",
      "repeating-radial-gradient"
    ]);
    function W(g) {
      g = t(g);
      for (let R of D)
        if (g.startsWith(`${R}(`))
          return !0;
      return !1;
    }
    let K = /* @__PURE__ */ new Set([
      "center",
      "top",
      "right",
      "bottom",
      "left"
    ]);
    function x(g) {
      let R = 0;
      return (0, n.splitAtTopLevelOnly)(g, "_").every((s) => (s = t(s), s.startsWith("var(") ? !0 : K.has(s) || P(s) || v(s) ? (R++, !0) : !1)) ? R > 0 : !1;
    }
    function S(g) {
      let R = 0;
      return (0, n.splitAtTopLevelOnly)(g, ",").every((s) => (s = t(s), s.startsWith("var(") ? !0 : s.includes(" ") && !/(['"])([^"']+)\1/g.test(s) || /^\d/g.test(s) ? !1 : (R++, !0))) ? R > 0 : !1;
    }
    let w = /* @__PURE__ */ new Set([
      "serif",
      "sans-serif",
      "monospace",
      "cursive",
      "fantasy",
      "system-ui",
      "ui-serif",
      "ui-sans-serif",
      "ui-monospace",
      "ui-rounded",
      "math",
      "emoji",
      "fangsong"
    ]);
    function m(g) {
      return w.has(g);
    }
    let E = /* @__PURE__ */ new Set([
      "xx-small",
      "x-small",
      "small",
      "medium",
      "large",
      "x-large",
      "xx-large",
      "xxx-large"
    ]);
    function _(g) {
      return E.has(g);
    }
    let b = /* @__PURE__ */ new Set([
      "larger",
      "smaller"
    ]);
    function T(g) {
      return b.has(g);
    }
  })($e)), $e;
}
var ze = {}, Dr;
function Qt() {
  return Dr || (Dr = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "backgroundSize", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const u = nt(), a = Qe();
    function o(i) {
      let n = [
        "cover",
        "contain"
      ];
      return (0, a.splitAtTopLevelOnly)(i, ",").every((r) => {
        let p = (0, a.splitAtTopLevelOnly)(r, "_").filter(Boolean);
        return p.length === 1 && n.includes(p[0]) ? !0 : p.length !== 1 && p.length !== 2 ? !1 : p.every((l) => (0, u.length)(l) || (0, u.percentage)(l) || l === "auto");
      });
    }
  })(ze)), ze;
}
var qr;
function Jt() {
  return qr || (qr = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function u(x, S) {
      for (var w in S) Object.defineProperty(x, w, {
        enumerable: !0,
        get: S[w]
      });
    }
    u(e, {
      updateAllClasses: function() {
        return t;
      },
      asValue: function() {
        return d;
      },
      parseColorFormat: function() {
        return O;
      },
      asColor: function() {
        return q;
      },
      asLookupValue: function() {
        return U;
      },
      typeMap: function() {
        return M;
      },
      coerceValue: function() {
        return W;
      },
      getMatchingTypes: function() {
        return K;
      }
    });
    const a = /* @__PURE__ */ l(Yt()), o = tt(), i = nt(), n = /* @__PURE__ */ l(Zr()), r = Qt(), p = Ke();
    function l(x) {
      return x && x.__esModule ? x : {
        default: x
      };
    }
    function t(x, S) {
      x.walkClasses((w) => {
        w.value = S(w.value), w.raws && w.raws.value && (w.raws.value = (0, a.default)(w.raws.value));
      });
    }
    function f(x, S) {
      if (!v(x))
        return;
      let w = x.slice(1, -1);
      if (S(w))
        return (0, i.normalize)(w);
    }
    function c(x, S = {}, w) {
      let m = S[x];
      if (m !== void 0)
        return (0, n.default)(m);
      if (v(x)) {
        let E = f(x, w);
        return E === void 0 ? void 0 : (0, n.default)(E);
      }
    }
    function d(x, S = {}, { validate: w = () => !0 } = {}) {
      var m;
      let E = (m = S.values) === null || m === void 0 ? void 0 : m[x];
      return E !== void 0 ? E : S.supportsNegativeValues && x.startsWith("-") ? c(x.slice(1), S.values, w) : f(x, w);
    }
    function v(x) {
      return x.startsWith("[") && x.endsWith("]");
    }
    function h(x) {
      let S = x.lastIndexOf("/"), w = x.lastIndexOf("[", S), m = x.indexOf("]", S);
      return x[S - 1] === "]" || x[S + 1] === "[" || w !== -1 && m !== -1 && w < S && S < m && (S = x.lastIndexOf("/", w)), S === -1 || S === x.length - 1 ? [
        x,
        void 0
      ] : v(x) && !x.includes("]/[") ? [
        x,
        void 0
      ] : [
        x.slice(0, S),
        x.slice(S + 1)
      ];
    }
    function O(x) {
      if (typeof x == "string" && x.includes("<alpha-value>")) {
        let S = x;
        return ({ opacityValue: w = 1 }) => S.replace(/<alpha-value>/g, w);
      }
      return x;
    }
    function P(x) {
      return (0, i.normalize)(x.slice(1, -1));
    }
    function q(x, S = {}, { tailwindConfig: w = {} } = {}) {
      var m;
      if (((m = S.values) === null || m === void 0 ? void 0 : m[x]) !== void 0) {
        var E;
        return O((E = S.values) === null || E === void 0 ? void 0 : E[x]);
      }
      let [_, b] = h(x);
      if (b !== void 0) {
        var T, g, R, $;
        let s = ($ = (T = S.values) === null || T === void 0 ? void 0 : T[_]) !== null && $ !== void 0 ? $ : v(_) ? _.slice(1, -1) : void 0;
        return s === void 0 ? void 0 : (s = O(s), v(b) ? (0, o.withAlphaValue)(s, P(b)) : ((g = w.theme) === null || g === void 0 || (R = g.opacity) === null || R === void 0 ? void 0 : R[b]) === void 0 ? void 0 : (0, o.withAlphaValue)(s, w.theme.opacity[b]));
      }
      return d(x, S, {
        validate: i.color
      });
    }
    function U(x, S = {}) {
      var w;
      return (w = S.values) === null || w === void 0 ? void 0 : w[x];
    }
    function k(x) {
      return (S, w) => d(S, w, {
        validate: x
      });
    }
    let M = {
      any: d,
      color: q,
      url: k(i.url),
      image: k(i.image),
      length: k(i.length),
      percentage: k(i.percentage),
      position: k(i.position),
      lookup: U,
      "generic-name": k(i.genericName),
      "family-name": k(i.familyName),
      number: k(i.number),
      "line-width": k(i.lineWidth),
      "absolute-size": k(i.absoluteSize),
      "relative-size": k(i.relativeSize),
      shadow: k(i.shadow),
      size: k(r.backgroundSize)
    }, y = Object.keys(M);
    function D(x, S) {
      let w = x.indexOf(S);
      return w === -1 ? [
        void 0,
        x
      ] : [
        x.slice(0, w),
        x.slice(w + 1)
      ];
    }
    function W(x, S, w, m) {
      if (w.values && S in w.values)
        for (let { type: _ } of x ?? []) {
          let b = M[_](S, w, {
            tailwindConfig: m
          });
          if (b !== void 0)
            return [
              b,
              _,
              null
            ];
        }
      if (v(S)) {
        let _ = S.slice(1, -1), [b, T] = D(_, ":");
        if (!/^[\w-_]+$/g.test(b))
          T = _;
        else if (b !== void 0 && !y.includes(b))
          return [];
        if (T.length > 0 && y.includes(b))
          return [
            d(`[${T}]`, w),
            b,
            null
          ];
      }
      let E = K(x, S, w, m);
      for (let _ of E)
        return _;
      return [];
    }
    function* K(x, S, w, m) {
      let E = (0, p.flagEnabled)(m, "generalizedModifiers"), [_, b] = h(S);
      if (E && w.modifiers != null && (w.modifiers === "any" || typeof w.modifiers == "object" && (b && v(b) || b in w.modifiers)) || (_ = S, b = void 0), b !== void 0 && _ === "" && (_ = "DEFAULT"), b !== void 0 && typeof w.modifiers == "object") {
        var g, R;
        let $ = (R = (g = w.modifiers) === null || g === void 0 ? void 0 : g[b]) !== null && R !== void 0 ? R : null;
        $ !== null ? b = $ : v(b) && (b = P(b));
      }
      for (let { type: $ } of x ?? []) {
        let s = M[$](_, w, {
          tailwindConfig: m
        });
        s !== void 0 && (yield [
          s,
          $,
          b ?? null
        ]);
      }
    }
  })(Se)), Se;
}
var Ie = {}, $r;
function Zt() {
  return $r || ($r = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return u;
      }
    });
    function u(a) {
      return typeof a == "function" ? a({}) : a;
    }
  })(Ie)), Ie;
}
var Lr;
function en() {
  return Lr || (Lr = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return w;
      }
    });
    const u = /* @__PURE__ */ v(Zr()), a = /* @__PURE__ */ v(zt()), o = /* @__PURE__ */ v(It()), i = /* @__PURE__ */ v(Ut()), n = Wt(), r = Bt(), p = Nt(), l = /* @__PURE__ */ v(Vt()), t = Ht(), f = Jt(), c = tt(), d = /* @__PURE__ */ v(Zt());
    function v(m) {
      return m && m.__esModule ? m : {
        default: m
      };
    }
    function h(m) {
      return typeof m == "function";
    }
    function O(m, ...E) {
      let _ = E.pop();
      for (let b of E)
        for (let T in b) {
          let g = _(m[T], b[T]);
          g === void 0 ? (0, l.default)(m[T]) && (0, l.default)(b[T]) ? m[T] = O({}, m[T], b[T], _) : m[T] = b[T] : m[T] = g;
        }
      return m;
    }
    const P = {
      colors: i.default,
      negative(m) {
        return Object.keys(m).filter((E) => m[E] !== "0").reduce((E, _) => {
          let b = (0, u.default)(m[_]);
          return b !== void 0 && (E[`-${_}`] = b), E;
        }, {});
      },
      breakpoints(m) {
        return Object.keys(m).filter((E) => typeof m[E] == "string").reduce((E, _) => ({
          ...E,
          [`screen-${_}`]: m[_]
        }), {});
      }
    };
    function q(m, ...E) {
      return h(m) ? m(...E) : m;
    }
    function U(m) {
      return m.reduce((E, { extend: _ }) => O(E, _, (b, T) => b === void 0 ? [
        T
      ] : Array.isArray(b) ? [
        T,
        ...b
      ] : [
        T,
        b
      ]), {});
    }
    function k(m) {
      return {
        ...m.reduce((E, _) => (0, n.defaults)(E, _), {}),
        // In order to resolve n config objects, we combine all of their `extend` properties
        // into arrays instead of objects so they aren't overridden.
        extend: U(m)
      };
    }
    function M(m, E) {
      if (Array.isArray(m) && (0, l.default)(m[0]))
        return m.concat(E);
      if (Array.isArray(E) && (0, l.default)(E[0]) && (0, l.default)(m))
        return [
          m,
          ...E
        ];
      if (Array.isArray(E))
        return E;
    }
    function y({ extend: m, ...E }) {
      return O(E, m, (_, b) => !h(_) && !b.some(h) ? O({}, _, ...b, M) : (T, g) => O({}, ...[
        _,
        ...b
      ].map((R) => q(R, T, g)), M));
    }
    function* D(m) {
      let E = (0, r.toPath)(m);
      if (E.length === 0 || (yield E, Array.isArray(m)))
        return;
      let _ = /^(.*?)\s*\/\s*([^/]+)$/, b = m.match(_);
      if (b !== null) {
        let [, T, g] = b, R = (0, r.toPath)(T);
        R.alpha = g, yield R;
      }
    }
    function W(m) {
      const E = (_, b) => {
        for (const T of D(_)) {
          let g = 0, R = m;
          for (; R != null && g < T.length; )
            R = R[T[g++]], R = h(R) && (T.alpha === void 0 || g <= T.length - 1) ? R(E, P) : R;
          if (R !== void 0) {
            if (T.alpha !== void 0) {
              let $ = (0, f.parseColorFormat)(R);
              return (0, c.withAlphaValue)($, T.alpha, (0, d.default)($));
            }
            return (0, l.default)(R) ? (0, t.cloneDeep)(R) : R;
          }
        }
        return b;
      };
      return Object.assign(E, {
        theme: E,
        ...P
      }), Object.keys(m).reduce((_, b) => (_[b] = h(m[b]) ? m[b](E, P) : m[b], _), {});
    }
    function K(m) {
      let E = [];
      return m.forEach((_) => {
        E = [
          ...E,
          _
        ];
        var b;
        const T = (b = _?.plugins) !== null && b !== void 0 ? b : [];
        T.length !== 0 && T.forEach((g) => {
          g.__isOptionsFunction && (g = g());
          var R;
          E = [
            ...E,
            ...K([
              (R = g?.config) !== null && R !== void 0 ? R : {}
            ])
          ];
        });
      }), E;
    }
    function x(m) {
      return [
        ...m
      ].reduceRight((_, b) => h(b) ? b({
        corePlugins: _
      }) : (0, o.default)(b, _), a.default);
    }
    function S(m) {
      return [
        ...m
      ].reduceRight((_, b) => [
        ..._,
        ...b
      ], []);
    }
    function w(m) {
      let E = [
        ...K(m),
        {
          prefix: "",
          important: !1,
          separator: ":"
        }
      ];
      var _, b;
      return (0, p.normalizeConfig)((0, n.defaults)({
        theme: W(y(k(E.map((T) => (_ = T?.theme) !== null && _ !== void 0 ? _ : {})))),
        corePlugins: x(E.map((T) => T.corePlugins)),
        plugins: S(m.map((T) => (b = T?.plugins) !== null && b !== void 0 ? b : []))
      }, ...E));
    }
  })(ye)), ye;
}
var Ue = {}, We, jr;
function rn() {
  return jr || (jr = 1, We = {
    content: [],
    presets: [],
    darkMode: "media",
    // or 'class'
    theme: {
      accentColor: ({ theme: e }) => ({
        ...e("colors"),
        auto: "auto"
      }),
      animation: {
        none: "none",
        spin: "spin 1s linear infinite",
        ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
        pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
        bounce: "bounce 1s infinite"
      },
      aria: {
        busy: 'busy="true"',
        checked: 'checked="true"',
        disabled: 'disabled="true"',
        expanded: 'expanded="true"',
        hidden: 'hidden="true"',
        pressed: 'pressed="true"',
        readonly: 'readonly="true"',
        required: 'required="true"',
        selected: 'selected="true"'
      },
      aspectRatio: {
        auto: "auto",
        square: "1 / 1",
        video: "16 / 9"
      },
      backdropBlur: ({ theme: e }) => e("blur"),
      backdropBrightness: ({ theme: e }) => e("brightness"),
      backdropContrast: ({ theme: e }) => e("contrast"),
      backdropGrayscale: ({ theme: e }) => e("grayscale"),
      backdropHueRotate: ({ theme: e }) => e("hueRotate"),
      backdropInvert: ({ theme: e }) => e("invert"),
      backdropOpacity: ({ theme: e }) => e("opacity"),
      backdropSaturate: ({ theme: e }) => e("saturate"),
      backdropSepia: ({ theme: e }) => e("sepia"),
      backgroundColor: ({ theme: e }) => e("colors"),
      backgroundImage: {
        none: "none",
        "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
        "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
        "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
        "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
        "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
        "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
        "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
        "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
      },
      backgroundOpacity: ({ theme: e }) => e("opacity"),
      backgroundPosition: {
        bottom: "bottom",
        center: "center",
        left: "left",
        "left-bottom": "left bottom",
        "left-top": "left top",
        right: "right",
        "right-bottom": "right bottom",
        "right-top": "right top",
        top: "top"
      },
      backgroundSize: {
        auto: "auto",
        cover: "cover",
        contain: "contain"
      },
      blur: {
        0: "0",
        none: "",
        sm: "4px",
        DEFAULT: "8px",
        md: "12px",
        lg: "16px",
        xl: "24px",
        "2xl": "40px",
        "3xl": "64px"
      },
      borderColor: ({ theme: e }) => ({
        ...e("colors"),
        DEFAULT: e("colors.gray.200", "currentColor")
      }),
      borderOpacity: ({ theme: e }) => e("opacity"),
      borderRadius: {
        none: "0px",
        sm: "0.125rem",
        DEFAULT: "0.25rem",
        md: "0.375rem",
        lg: "0.5rem",
        xl: "0.75rem",
        "2xl": "1rem",
        "3xl": "1.5rem",
        full: "9999px"
      },
      borderSpacing: ({ theme: e }) => ({
        ...e("spacing")
      }),
      borderWidth: {
        DEFAULT: "1px",
        0: "0px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      boxShadow: {
        sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
        DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
        md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
        lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
        xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
        "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
        inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
        none: "none"
      },
      boxShadowColor: ({ theme: e }) => e("colors"),
      brightness: {
        0: "0",
        50: ".5",
        75: ".75",
        90: ".9",
        95: ".95",
        100: "1",
        105: "1.05",
        110: "1.1",
        125: "1.25",
        150: "1.5",
        200: "2"
      },
      caretColor: ({ theme: e }) => e("colors"),
      colors: ({ colors: e }) => ({
        inherit: e.inherit,
        current: e.current,
        transparent: e.transparent,
        black: e.black,
        white: e.white,
        slate: e.slate,
        gray: e.gray,
        zinc: e.zinc,
        neutral: e.neutral,
        stone: e.stone,
        red: e.red,
        orange: e.orange,
        amber: e.amber,
        yellow: e.yellow,
        lime: e.lime,
        green: e.green,
        emerald: e.emerald,
        teal: e.teal,
        cyan: e.cyan,
        sky: e.sky,
        blue: e.blue,
        indigo: e.indigo,
        violet: e.violet,
        purple: e.purple,
        fuchsia: e.fuchsia,
        pink: e.pink,
        rose: e.rose
      }),
      columns: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        "3xs": "16rem",
        "2xs": "18rem",
        xs: "20rem",
        sm: "24rem",
        md: "28rem",
        lg: "32rem",
        xl: "36rem",
        "2xl": "42rem",
        "3xl": "48rem",
        "4xl": "56rem",
        "5xl": "64rem",
        "6xl": "72rem",
        "7xl": "80rem"
      },
      container: {},
      content: {
        none: "none"
      },
      contrast: {
        0: "0",
        50: ".5",
        75: ".75",
        100: "1",
        125: "1.25",
        150: "1.5",
        200: "2"
      },
      cursor: {
        auto: "auto",
        default: "default",
        pointer: "pointer",
        wait: "wait",
        text: "text",
        move: "move",
        help: "help",
        "not-allowed": "not-allowed",
        none: "none",
        "context-menu": "context-menu",
        progress: "progress",
        cell: "cell",
        crosshair: "crosshair",
        "vertical-text": "vertical-text",
        alias: "alias",
        copy: "copy",
        "no-drop": "no-drop",
        grab: "grab",
        grabbing: "grabbing",
        "all-scroll": "all-scroll",
        "col-resize": "col-resize",
        "row-resize": "row-resize",
        "n-resize": "n-resize",
        "e-resize": "e-resize",
        "s-resize": "s-resize",
        "w-resize": "w-resize",
        "ne-resize": "ne-resize",
        "nw-resize": "nw-resize",
        "se-resize": "se-resize",
        "sw-resize": "sw-resize",
        "ew-resize": "ew-resize",
        "ns-resize": "ns-resize",
        "nesw-resize": "nesw-resize",
        "nwse-resize": "nwse-resize",
        "zoom-in": "zoom-in",
        "zoom-out": "zoom-out"
      },
      divideColor: ({ theme: e }) => e("borderColor"),
      divideOpacity: ({ theme: e }) => e("borderOpacity"),
      divideWidth: ({ theme: e }) => e("borderWidth"),
      dropShadow: {
        sm: "0 1px 1px rgb(0 0 0 / 0.05)",
        DEFAULT: ["0 1px 2px rgb(0 0 0 / 0.1)", "0 1px 1px rgb(0 0 0 / 0.06)"],
        md: ["0 4px 3px rgb(0 0 0 / 0.07)", "0 2px 2px rgb(0 0 0 / 0.06)"],
        lg: ["0 10px 8px rgb(0 0 0 / 0.04)", "0 4px 3px rgb(0 0 0 / 0.1)"],
        xl: ["0 20px 13px rgb(0 0 0 / 0.03)", "0 8px 5px rgb(0 0 0 / 0.08)"],
        "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
        none: "0 0 #0000"
      },
      fill: ({ theme: e }) => ({
        none: "none",
        ...e("colors")
      }),
      flex: {
        1: "1 1 0%",
        auto: "1 1 auto",
        initial: "0 1 auto",
        none: "none"
      },
      flexBasis: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%"
      }),
      flexGrow: {
        0: "0",
        DEFAULT: "1"
      },
      flexShrink: {
        0: "0",
        DEFAULT: "1"
      },
      fontFamily: {
        sans: [
          "ui-sans-serif",
          "system-ui",
          "sans-serif",
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"',
          '"Noto Color Emoji"'
        ],
        serif: ["ui-serif", "Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
        mono: [
          "ui-monospace",
          "SFMono-Regular",
          "Menlo",
          "Monaco",
          "Consolas",
          '"Liberation Mono"',
          '"Courier New"',
          "monospace"
        ]
      },
      fontSize: {
        xs: ["0.75rem", { lineHeight: "1rem" }],
        sm: ["0.875rem", { lineHeight: "1.25rem" }],
        base: ["1rem", { lineHeight: "1.5rem" }],
        lg: ["1.125rem", { lineHeight: "1.75rem" }],
        xl: ["1.25rem", { lineHeight: "1.75rem" }],
        "2xl": ["1.5rem", { lineHeight: "2rem" }],
        "3xl": ["1.875rem", { lineHeight: "2.25rem" }],
        "4xl": ["2.25rem", { lineHeight: "2.5rem" }],
        "5xl": ["3rem", { lineHeight: "1" }],
        "6xl": ["3.75rem", { lineHeight: "1" }],
        "7xl": ["4.5rem", { lineHeight: "1" }],
        "8xl": ["6rem", { lineHeight: "1" }],
        "9xl": ["8rem", { lineHeight: "1" }]
      },
      fontWeight: {
        thin: "100",
        extralight: "200",
        light: "300",
        normal: "400",
        medium: "500",
        semibold: "600",
        bold: "700",
        extrabold: "800",
        black: "900"
      },
      gap: ({ theme: e }) => e("spacing"),
      gradientColorStops: ({ theme: e }) => e("colors"),
      gradientColorStopPositions: {
        "0%": "0%",
        "5%": "5%",
        "10%": "10%",
        "15%": "15%",
        "20%": "20%",
        "25%": "25%",
        "30%": "30%",
        "35%": "35%",
        "40%": "40%",
        "45%": "45%",
        "50%": "50%",
        "55%": "55%",
        "60%": "60%",
        "65%": "65%",
        "70%": "70%",
        "75%": "75%",
        "80%": "80%",
        "85%": "85%",
        "90%": "90%",
        "95%": "95%",
        "100%": "100%"
      },
      grayscale: {
        0: "0",
        DEFAULT: "100%"
      },
      gridAutoColumns: {
        auto: "auto",
        min: "min-content",
        max: "max-content",
        fr: "minmax(0, 1fr)"
      },
      gridAutoRows: {
        auto: "auto",
        min: "min-content",
        max: "max-content",
        fr: "minmax(0, 1fr)"
      },
      gridColumn: {
        auto: "auto",
        "span-1": "span 1 / span 1",
        "span-2": "span 2 / span 2",
        "span-3": "span 3 / span 3",
        "span-4": "span 4 / span 4",
        "span-5": "span 5 / span 5",
        "span-6": "span 6 / span 6",
        "span-7": "span 7 / span 7",
        "span-8": "span 8 / span 8",
        "span-9": "span 9 / span 9",
        "span-10": "span 10 / span 10",
        "span-11": "span 11 / span 11",
        "span-12": "span 12 / span 12",
        "span-full": "1 / -1"
      },
      gridColumnEnd: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridColumnStart: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridRow: {
        auto: "auto",
        "span-1": "span 1 / span 1",
        "span-2": "span 2 / span 2",
        "span-3": "span 3 / span 3",
        "span-4": "span 4 / span 4",
        "span-5": "span 5 / span 5",
        "span-6": "span 6 / span 6",
        "span-7": "span 7 / span 7",
        "span-8": "span 8 / span 8",
        "span-9": "span 9 / span 9",
        "span-10": "span 10 / span 10",
        "span-11": "span 11 / span 11",
        "span-12": "span 12 / span 12",
        "span-full": "1 / -1"
      },
      gridRowEnd: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridRowStart: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridTemplateColumns: {
        none: "none",
        subgrid: "subgrid",
        1: "repeat(1, minmax(0, 1fr))",
        2: "repeat(2, minmax(0, 1fr))",
        3: "repeat(3, minmax(0, 1fr))",
        4: "repeat(4, minmax(0, 1fr))",
        5: "repeat(5, minmax(0, 1fr))",
        6: "repeat(6, minmax(0, 1fr))",
        7: "repeat(7, minmax(0, 1fr))",
        8: "repeat(8, minmax(0, 1fr))",
        9: "repeat(9, minmax(0, 1fr))",
        10: "repeat(10, minmax(0, 1fr))",
        11: "repeat(11, minmax(0, 1fr))",
        12: "repeat(12, minmax(0, 1fr))"
      },
      gridTemplateRows: {
        none: "none",
        subgrid: "subgrid",
        1: "repeat(1, minmax(0, 1fr))",
        2: "repeat(2, minmax(0, 1fr))",
        3: "repeat(3, minmax(0, 1fr))",
        4: "repeat(4, minmax(0, 1fr))",
        5: "repeat(5, minmax(0, 1fr))",
        6: "repeat(6, minmax(0, 1fr))",
        7: "repeat(7, minmax(0, 1fr))",
        8: "repeat(8, minmax(0, 1fr))",
        9: "repeat(9, minmax(0, 1fr))",
        10: "repeat(10, minmax(0, 1fr))",
        11: "repeat(11, minmax(0, 1fr))",
        12: "repeat(12, minmax(0, 1fr))"
      },
      height: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      hueRotate: {
        0: "0deg",
        15: "15deg",
        30: "30deg",
        60: "60deg",
        90: "90deg",
        180: "180deg"
      },
      inset: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        full: "100%"
      }),
      invert: {
        0: "0",
        DEFAULT: "100%"
      },
      keyframes: {
        spin: {
          to: {
            transform: "rotate(360deg)"
          }
        },
        ping: {
          "75%, 100%": {
            transform: "scale(2)",
            opacity: "0"
          }
        },
        pulse: {
          "50%": {
            opacity: ".5"
          }
        },
        bounce: {
          "0%, 100%": {
            transform: "translateY(-25%)",
            animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
          },
          "50%": {
            transform: "none",
            animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
          }
        }
      },
      letterSpacing: {
        tighter: "-0.05em",
        tight: "-0.025em",
        normal: "0em",
        wide: "0.025em",
        wider: "0.05em",
        widest: "0.1em"
      },
      lineHeight: {
        none: "1",
        tight: "1.25",
        snug: "1.375",
        normal: "1.5",
        relaxed: "1.625",
        loose: "2",
        3: ".75rem",
        4: "1rem",
        5: "1.25rem",
        6: "1.5rem",
        7: "1.75rem",
        8: "2rem",
        9: "2.25rem",
        10: "2.5rem"
      },
      listStyleType: {
        none: "none",
        disc: "disc",
        decimal: "decimal"
      },
      listStyleImage: {
        none: "none"
      },
      margin: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing")
      }),
      lineClamp: {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6"
      },
      maxHeight: ({ theme: e }) => ({
        ...e("spacing"),
        none: "none",
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      maxWidth: ({ theme: e, breakpoints: u }) => ({
        ...e("spacing"),
        none: "none",
        xs: "20rem",
        sm: "24rem",
        md: "28rem",
        lg: "32rem",
        xl: "36rem",
        "2xl": "42rem",
        "3xl": "48rem",
        "4xl": "56rem",
        "5xl": "64rem",
        "6xl": "72rem",
        "7xl": "80rem",
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content",
        prose: "65ch",
        ...u(e("screens"))
      }),
      minHeight: ({ theme: e }) => ({
        ...e("spacing"),
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      minWidth: ({ theme: e }) => ({
        ...e("spacing"),
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      objectPosition: {
        bottom: "bottom",
        center: "center",
        left: "left",
        "left-bottom": "left bottom",
        "left-top": "left top",
        right: "right",
        "right-bottom": "right bottom",
        "right-top": "right top",
        top: "top"
      },
      opacity: {
        0: "0",
        5: "0.05",
        10: "0.1",
        15: "0.15",
        20: "0.2",
        25: "0.25",
        30: "0.3",
        35: "0.35",
        40: "0.4",
        45: "0.45",
        50: "0.5",
        55: "0.55",
        60: "0.6",
        65: "0.65",
        70: "0.7",
        75: "0.75",
        80: "0.8",
        85: "0.85",
        90: "0.9",
        95: "0.95",
        100: "1"
      },
      order: {
        first: "-9999",
        last: "9999",
        none: "0",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12"
      },
      outlineColor: ({ theme: e }) => e("colors"),
      outlineOffset: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      outlineWidth: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      padding: ({ theme: e }) => e("spacing"),
      placeholderColor: ({ theme: e }) => e("colors"),
      placeholderOpacity: ({ theme: e }) => e("opacity"),
      ringColor: ({ theme: e }) => ({
        DEFAULT: e("colors.blue.500", "#3b82f6"),
        ...e("colors")
      }),
      ringOffsetColor: ({ theme: e }) => e("colors"),
      ringOffsetWidth: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      ringOpacity: ({ theme: e }) => ({
        DEFAULT: "0.5",
        ...e("opacity")
      }),
      ringWidth: {
        DEFAULT: "3px",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      rotate: {
        0: "0deg",
        1: "1deg",
        2: "2deg",
        3: "3deg",
        6: "6deg",
        12: "12deg",
        45: "45deg",
        90: "90deg",
        180: "180deg"
      },
      saturate: {
        0: "0",
        50: ".5",
        100: "1",
        150: "1.5",
        200: "2"
      },
      scale: {
        0: "0",
        50: ".5",
        75: ".75",
        90: ".9",
        95: ".95",
        100: "1",
        105: "1.05",
        110: "1.1",
        125: "1.25",
        150: "1.5"
      },
      screens: {
        sm: "640px",
        md: "768px",
        lg: "1024px",
        xl: "1280px",
        "2xl": "1536px"
      },
      scrollMargin: ({ theme: e }) => ({
        ...e("spacing")
      }),
      scrollPadding: ({ theme: e }) => e("spacing"),
      sepia: {
        0: "0",
        DEFAULT: "100%"
      },
      skew: {
        0: "0deg",
        1: "1deg",
        2: "2deg",
        3: "3deg",
        6: "6deg",
        12: "12deg"
      },
      space: ({ theme: e }) => ({
        ...e("spacing")
      }),
      spacing: {
        px: "1px",
        0: "0px",
        0.5: "0.125rem",
        1: "0.25rem",
        1.5: "0.375rem",
        2: "0.5rem",
        2.5: "0.625rem",
        3: "0.75rem",
        3.5: "0.875rem",
        4: "1rem",
        5: "1.25rem",
        6: "1.5rem",
        7: "1.75rem",
        8: "2rem",
        9: "2.25rem",
        10: "2.5rem",
        11: "2.75rem",
        12: "3rem",
        14: "3.5rem",
        16: "4rem",
        20: "5rem",
        24: "6rem",
        28: "7rem",
        32: "8rem",
        36: "9rem",
        40: "10rem",
        44: "11rem",
        48: "12rem",
        52: "13rem",
        56: "14rem",
        60: "15rem",
        64: "16rem",
        72: "18rem",
        80: "20rem",
        96: "24rem"
      },
      stroke: ({ theme: e }) => ({
        none: "none",
        ...e("colors")
      }),
      strokeWidth: {
        0: "0",
        1: "1",
        2: "2"
      },
      supports: {},
      data: {},
      textColor: ({ theme: e }) => e("colors"),
      textDecorationColor: ({ theme: e }) => e("colors"),
      textDecorationThickness: {
        auto: "auto",
        "from-font": "from-font",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      textIndent: ({ theme: e }) => ({
        ...e("spacing")
      }),
      textOpacity: ({ theme: e }) => e("opacity"),
      textUnderlineOffset: {
        auto: "auto",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      transformOrigin: {
        center: "center",
        top: "top",
        "top-right": "top right",
        right: "right",
        "bottom-right": "bottom right",
        bottom: "bottom",
        "bottom-left": "bottom left",
        left: "left",
        "top-left": "top left"
      },
      transitionDelay: {
        0: "0s",
        75: "75ms",
        100: "100ms",
        150: "150ms",
        200: "200ms",
        300: "300ms",
        500: "500ms",
        700: "700ms",
        1e3: "1000ms"
      },
      transitionDuration: {
        DEFAULT: "150ms",
        0: "0s",
        75: "75ms",
        100: "100ms",
        150: "150ms",
        200: "200ms",
        300: "300ms",
        500: "500ms",
        700: "700ms",
        1e3: "1000ms"
      },
      transitionProperty: {
        none: "none",
        all: "all",
        DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
        colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
        opacity: "opacity",
        shadow: "box-shadow",
        transform: "transform"
      },
      transitionTimingFunction: {
        DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
        linear: "linear",
        in: "cubic-bezier(0.4, 0, 1, 1)",
        out: "cubic-bezier(0, 0, 0.2, 1)",
        "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
      },
      translate: ({ theme: e }) => ({
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        full: "100%"
      }),
      size: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      width: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%",
        screen: "100vw",
        svw: "100svw",
        lvw: "100lvw",
        dvw: "100dvw",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      willChange: {
        auto: "auto",
        scroll: "scroll-position",
        contents: "contents",
        transform: "transform"
      },
      zIndex: {
        auto: "auto",
        0: "0",
        10: "10",
        20: "20",
        30: "30",
        40: "40",
        50: "50"
      }
    },
    plugins: []
  }), We;
}
var Fr;
function tn() {
  return Fr || (Fr = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const u = /* @__PURE__ */ o(rn()), a = Ke();
    function o(n) {
      return n && n.__esModule ? n : {
        default: n
      };
    }
    function i(n) {
      var r;
      const p = ((r = n?.presets) !== null && r !== void 0 ? r : [
        u.default
      ]).slice().reverse().flatMap((f) => i(f instanceof Function ? f() : f)), l = {
        // Add experimental configs here...
        respectDefaultRingColorOpacity: {
          theme: {
            ringColor: ({ theme: f }) => ({
              DEFAULT: "#3b82f67f",
              ...f("colors")
            })
          }
        },
        disableColorOpacityUtilitiesByDefault: {
          corePlugins: {
            backgroundOpacity: !1,
            borderOpacity: !1,
            divideOpacity: !1,
            placeholderOpacity: !1,
            ringOpacity: !1,
            textOpacity: !1
          }
        }
      }, t = Object.keys(l).filter((f) => (0, a.flagEnabled)(n, f)).map((f) => l[f]);
      return [
        n,
        ...t,
        ...p
      ];
    }
  })(Ue)), Ue;
}
var zr;
function nn() {
  return zr || (zr = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return i;
      }
    });
    const u = /* @__PURE__ */ o(en()), a = /* @__PURE__ */ o(tn());
    function o(n) {
      return n && n.__esModule ? n : {
        default: n
      };
    }
    function i(...n) {
      let [, ...r] = (0, a.default)(n[0]);
      return (0, u.default)([
        ...n,
        ...r
      ]);
    }
  })(he)), he;
}
var Be, Ir;
function an() {
  if (Ir) return Be;
  Ir = 1;
  let e = nn();
  return Be = (e.__esModule ? e : { default: e }).default, Be;
}
var on = an();
const ln = /* @__PURE__ */ se(on), Ur = {
  safelist: [{ pattern: /text-.*/ }],
  theme: {
    colors: {
      background: "hsl(var(--background))",
      foreground: "hsl(var(--foreground))",
      "branded-background": "hsl(var(--branded-background))",
      "branded-foreground": "hsl(var(--branded-foreground))",
      "foreground-color": "hsl(var(--background))",
      primary: {
        foreground: "hsl(var(--primary-foreground))",
        "foreground-color": "hsl(var(--primary))",
        "foreground-dark": "hsl(var(--primary-dark))",
        DEFAULT: "hsl(var(--primary))",
        hover: "hsl(var(--primary-dark))",
        dark: "hsl(var(--primary-dark))",
        light: "hsl(var(--primary-light))"
      },
      secondary: {
        foreground: "hsl(var(--secondary-foreground))",
        "foreground-color": "hsl(var(--secondary))",
        "foreground-dark": "hsl(var(--secondary-dark))",
        DEFAULT: "hsl(var(--secondary))",
        hover: "hsl(var(--secondary-dark))",
        dark: "hsl(var(--secondary-dark))",
        light: "hsl(var(--secondary-light))"
      },
      tertiary: {
        foreground: "hsl(var(--tertiary-foreground))",
        "foreground-color": "hsl(var(--tertiary))",
        "foreground-dark": "hsl(var(--tertiary-dark))",
        DEFAULT: "hsl(var(--tertiary))",
        hover: "hsl(var(--tertiary-dark))",
        dark: "hsl(var(--tertiary-dark))",
        light: "hsl(var(--tertiary-light))"
      },
      success: {
        foreground: "hsl(var(--success-foreground))",
        "foreground-color": "hsl(var(--success))",
        "foreground-dark": "hsl(var(--success-dark))",
        light: "hsl(var(--success-light))",
        DEFAULT: "hsl(var(--success))",
        hover: "hsl(var(--success-dark))",
        dark: "hsl(var(--success-dark))"
      },
      info: {
        foreground: "hsl(var(--info-foreground))",
        "foreground-color": "hsl(var(--info))",
        "foreground-dark": "hsl(var(--info-dark))",
        light: "hsl(var(--info-light))",
        DEFAULT: "hsl(var(--info))",
        hover: "hsl(var(--info-dark))",
        dark: "hsl(var(--info-dark))"
      },
      warning: {
        foreground: "hsl(var(--warning-foreground))",
        "foreground-color": "hsl(var(--warning))",
        "foreground-dark": "hsl(var(--warning-dark))",
        light: "hsl(var(--warning-light))",
        DEFAULT: "hsl(var(--warning))",
        hover: "hsl(var(--warning-dark))",
        dark: "hsl(var(--warning-dark))"
      },
      destructive: {
        foreground: "hsl(var(--destructive-foreground))",
        "foreground-color": "hsl(var(--destructive))",
        "foreground-dark": "hsl(var(--destructive-dark))",
        light: "hsl(var(--destructive-light))",
        DEFAULT: "hsl(var(--destructive))",
        hover: "hsl(var(--destructive-hover))",
        dark: "hsl(var(--destructive-dark))"
      },
      runkeeper: {
        foreground: "hsl(var(--white))",
        "foreground-color": "hsl(var(--runkeeper))",
        light: "",
        DEFAULT: "hsl(var(--runkeeper))",
        hover: "",
        dark: ""
      },
      white: "hsl(var(--white))",
      gray: {
        foreground: "hsl(var(--gray-900))",
        "foreground-color": "hsl(var(--gray-100))",
        "foreground-dark": "hsl(var(--gray-900))",
        light: "hsl(var(--gray-10))",
        DEFAULT: "hsl(var(--gray-100))",
        hover: "hsl(var(--gray-600))",
        dark: "hsl(var(--gray-900))",
        100: "hsl(var(--gray-10))",
        200: "hsl(var(--gray-30))",
        300: "hsl(var(--gray-50))",
        400: "hsl(var(--gray-100))",
        500: "hsl(var(--gray-200))",
        600: "hsl(var(--gray-300))",
        700: "hsl(var(--gray-600))",
        800: "hsl(var(--gray-700))",
        900: "hsl(var(--gray-900))"
      },
      light: "hsl(var(--light))",
      dark: "hsl(var(--dark))",
      black: "hsl(var(--black))",
      menuBg: "hsl(var(--menu-bg))",
      transparent: "hsla(var(--transparent))",
      accent: "hsl(var(--accent))",
      "accent-foreground": "hsl(var(--accent-foreground))",
      muted: "hsl(var(--muted))",
      "muted-foreground": "hsl(var(--muted-foreground))",
      skeleton: {
        100: "hsl(var(--skeleton-100))",
        200: "hsl(var(--skeleton-200))",
        300: "hsl(var(--skeleton-300))",
        400: "hsl(var(--skeleton-400))"
      },
      border: "hsl(var(--border))",
      chart: {
        aqua: "hsl(var(--chart-aqua))",
        yellow: "hsl(var(--chart-yellow))",
        blue: "hsl(var(--chart-blue))",
        purple: "hsl(var(--chart-purple))",
        orange: "hsl(var(--chart-orange))",
        green: "hsl(var(--chart-green))",
        pink: "hsl(var(--chart-pink))",
        teal: "hsl(var(--chart-teal))",
        red: "hsl(var(--chart-red))"
      }
    },
    spacing: {
      0: "0px",
      1: "1px",
      2: "2px",
      3: "4px",
      4: "8px",
      5: "12px",
      6: "16px",
      7: "24px",
      8: "32px",
      9: "36px",
      // to align with shadCn styles
      10: "40px",
      // to align with shadCn styles
      11: "44px"
      // to align with shadCn styles
    },
    fontFamily: {
      sans: ["Open Sans", "Noto Sans JP", "Noto Sans Thai", "sans-serif"],
      montserrat: ["Montserrat", "sans-serif"],
      "permanent-marker": ["Permanent Marker", "cursive"]
    },
    fontWeight: {
      medium: "400",
      semibold: "600",
      bold: "700"
    },
    fontSize: {
      display: "var(--font-display)",
      "3xl": "var(--font-3xl)",
      "2xl": "var(--font-2xl)",
      xl: "var(--font-xl)",
      lg: "var(--font-lg)",
      base: "inherit",
      md: "var(--font-md)",
      sm: "var(--font-sm)"
    },
    screens: {
      sm: "576px",
      md: "768px",
      lg: "992px",
      xl: "1200px",
      "2xl": "1440px"
    },
    extend: {
      boxShadow: {
        DEFAULT: "0 2px 4px 0 hsla(0, 0%, 10%, 0.06)",
        button: "0 2px 4px 0 hsla(0, 0%, 0%, 0.08)",
        floating: "0 2px 8px 0 hsla(0, 0%, 10%, 0.16)"
      },
      colors: {
        background: "hsl(var(--background))",
        foreground: "hsl(var(--foreground))",
        popover: {
          DEFAULT: "hsl(var(--popover))",
          foreground: "hsl(var(--popover-foreground))"
        },
        card: {
          DEFAULT: "hsl(var(--card))",
          foreground: "hsl(var(--card-foreground))"
        },
        checkbox: {
          DEFAULT: "hsl(var(--checkbox-checked-bg))",
          foreground: "hsl(var(--checkbox-checked-foreground))"
        }
      },
      zIndex: {
        1: "1",
        2: "2",
        // Floating chrome (AI chat launcher) sits above sticky page UI (z-10) and below
        // dialogs, sheets, and popovers (z-50).
        floating: "40"
      },
      keyframes: {
        "accordion-down": {
          from: { height: "0" },
          to: { height: "var(--radix-accordion-content-height)" }
        },
        "accordion-up": {
          from: { height: "var(--radix-accordion-content-height)" },
          to: { height: "0" }
        }
      },
      animation: {
        "accordion-down": "accordion-down 0.2s ease-out",
        "accordion-up": "accordion-up 0.2s ease-out"
      }
    }
  }
};
var Ne = {}, Ve = {}, Wr;
function sn() {
  return Wr || (Wr = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return a;
      }
    });
    function u(o, i) {
      return {
        handler: o,
        config: i
      };
    }
    u.withOptions = function(o, i = () => ({})) {
      const n = function(r) {
        return {
          __options: r,
          handler: o(r),
          config: i(r)
        };
      };
      return n.__isOptionsFunction = !0, n.__pluginFunction = o, n.__configFunction = i, n;
    };
    const a = u;
  })(Ve)), Ve;
}
var Br;
function un() {
  return Br || (Br = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const u = /* @__PURE__ */ a(sn());
    function a(i) {
      return i && i.__esModule ? i : {
        default: i
      };
    }
    const o = u.default;
  })(Ne)), Ne;
}
var He, Nr;
function cn() {
  if (Nr) return He;
  Nr = 1;
  let e = un();
  return He = (e.__esModule ? e : { default: e }).default, He;
}
var Ye, Vr;
function fn() {
  if (Vr) return Ye;
  Vr = 1;
  const e = cn();
  function u(a) {
    return Object.fromEntries(
      Object.entries(a).filter(([o]) => o !== "DEFAULT")
    );
  }
  return Ye = e(
    ({ addUtilities: a, matchUtilities: o, theme: i }) => {
      a({
        "@keyframes enter": i("keyframes.enter"),
        "@keyframes exit": i("keyframes.exit"),
        ".animate-in": {
          animationName: "enter",
          animationDuration: i("animationDuration.DEFAULT"),
          "--tw-enter-opacity": "initial",
          "--tw-enter-scale": "initial",
          "--tw-enter-rotate": "initial",
          "--tw-enter-translate-x": "initial",
          "--tw-enter-translate-y": "initial"
        },
        ".animate-out": {
          animationName: "exit",
          animationDuration: i("animationDuration.DEFAULT"),
          "--tw-exit-opacity": "initial",
          "--tw-exit-scale": "initial",
          "--tw-exit-rotate": "initial",
          "--tw-exit-translate-x": "initial",
          "--tw-exit-translate-y": "initial"
        }
      }), o(
        {
          "fade-in": (n) => ({ "--tw-enter-opacity": n }),
          "fade-out": (n) => ({ "--tw-exit-opacity": n })
        },
        { values: i("animationOpacity") }
      ), o(
        {
          "zoom-in": (n) => ({ "--tw-enter-scale": n }),
          "zoom-out": (n) => ({ "--tw-exit-scale": n })
        },
        { values: i("animationScale") }
      ), o(
        {
          "spin-in": (n) => ({ "--tw-enter-rotate": n }),
          "spin-out": (n) => ({ "--tw-exit-rotate": n })
        },
        { values: i("animationRotate") }
      ), o(
        {
          "slide-in-from-top": (n) => ({
            "--tw-enter-translate-y": `-${n}`
          }),
          "slide-in-from-bottom": (n) => ({
            "--tw-enter-translate-y": n
          }),
          "slide-in-from-left": (n) => ({
            "--tw-enter-translate-x": `-${n}`
          }),
          "slide-in-from-right": (n) => ({
            "--tw-enter-translate-x": n
          }),
          "slide-out-to-top": (n) => ({
            "--tw-exit-translate-y": `-${n}`
          }),
          "slide-out-to-bottom": (n) => ({
            "--tw-exit-translate-y": n
          }),
          "slide-out-to-left": (n) => ({
            "--tw-exit-translate-x": `-${n}`
          }),
          "slide-out-to-right": (n) => ({
            "--tw-exit-translate-x": n
          })
        },
        { values: i("animationTranslate") }
      ), o(
        { duration: (n) => ({ animationDuration: n }) },
        { values: u(i("animationDuration")) }
      ), o(
        { delay: (n) => ({ animationDelay: n }) },
        { values: i("animationDelay") }
      ), o(
        { ease: (n) => ({ animationTimingFunction: n }) },
        { values: u(i("animationTimingFunction")) }
      ), a({
        ".running": { animationPlayState: "running" },
        ".paused": { animationPlayState: "paused" }
      }), o(
        { "fill-mode": (n) => ({ animationFillMode: n }) },
        { values: i("animationFillMode") }
      ), o(
        { direction: (n) => ({ animationDirection: n }) },
        { values: i("animationDirection") }
      ), o(
        { repeat: (n) => ({ animationIterationCount: n }) },
        { values: i("animationRepeat") }
      );
    },
    {
      theme: {
        extend: {
          animationDelay: ({ theme: a }) => ({
            ...a("transitionDelay")
          }),
          animationDuration: ({ theme: a }) => ({
            0: "0ms",
            ...a("transitionDuration")
          }),
          animationTimingFunction: ({ theme: a }) => ({
            ...a("transitionTimingFunction")
          }),
          animationFillMode: {
            none: "none",
            forwards: "forwards",
            backwards: "backwards",
            both: "both"
          },
          animationDirection: {
            normal: "normal",
            reverse: "reverse",
            alternate: "alternate",
            "alternate-reverse": "alternate-reverse"
          },
          animationOpacity: ({ theme: a }) => ({
            DEFAULT: 0,
            ...a("opacity")
          }),
          animationTranslate: ({ theme: a }) => ({
            DEFAULT: "100%",
            ...a("translate")
          }),
          animationScale: ({ theme: a }) => ({
            DEFAULT: 0,
            ...a("scale")
          }),
          animationRotate: ({ theme: a }) => ({
            DEFAULT: "30deg",
            ...a("rotate")
          }),
          animationRepeat: {
            0: "0",
            1: "1",
            infinite: "infinite"
          },
          keyframes: {
            enter: {
              from: {
                opacity: "var(--tw-enter-opacity, 1)",
                transform: "translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0))"
              }
            },
            exit: {
              to: {
                opacity: "var(--tw-exit-opacity, 1)",
                transform: "translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0))"
              }
            }
          }
        }
      }
    }
  ), Ye;
}
var dn = fn();
const pn = /* @__PURE__ */ se(dn), mn = {
  presets: [Ur],
  safelist: [
    ...Ur?.safelist ?? [],
    {
      pattern: /(mt|mb|ml|mr|gap|gap-x|gap-y|col-span)-([0-9])/,
      variants: ["md"]
    },
    {
      pattern: /ml-auto/,
      variants: ["md"]
    },
    {
      pattern: /grid-cols-([0-9])/,
      variants: ["sm", "md", "lg"]
    },
    {
      pattern: /auto-cols-/
    },
    {
      pattern: /(-)?(right-|bottom-)/
    },
    {
      pattern: /(justify-center|justify-start)/,
      variants: ["sm", "md", "lg"]
    },
    { pattern: /--color-chart/ },
    // hardcoded classes that we need
    "line-through",
    "break-words",
    "w-[64px]",
    "w-[171px]",
    "w-[300px]",
    "w-[320px]",
    "min-w-[320px]",
    "max-w-[380px]",
    "max-w-[576px]",
    "md:w-auto",
    "min-w-fit",
    "p-2",
    "pb-6",
    "lg:p-0",
    "lg:min-w-0",
    "h-[48px]",
    "h-[400px]",
    "md:flex-1",
    "items-stretch",
    "md:flex-wrap",
    "md:overflow-x-visible",
    "auto-cols-[320px]",
    "grid-flow-col",
    "md:grid-flow-row",
    "md:grid-cols-[repeat(3,minmax(0,380px))]",
    // Content block classes
    "[&_ul]:list-disc",
    "[&_ul]:ml-7",
    "[&_ul]:my-7",
    "[&_ul>li]:mt-2",
    "[&_ol]:list-decimal",
    "[&_ol]:ml-7",
    "[&_ol]:my-7",
    "[&_ol>li]:mt-2",
    "[&_img]:mx-auto",
    "[&_img]:block",
    "[&_blockquote]:mt-6",
    "[&_blockquote]:border-l-2",
    "[&_blockquote]:pl-6",
    "[&_blockquote]:italic",
    "[&_table]:w-full",
    "[&_table]:caption-bottom",
    "[&_table]:text-sm",
    "[&_caption]:text-muted-foreground",
    "[&_caption]:mt-4",
    "[&_caption]:text-sm",
    "[&_thead]:border-b",
    "[&_tbody>tr:last-child]:border-0",
    "[&_tr]:border-b",
    "[&_tr]:border-gray",
    "[&_tr:hover]:bg-muted",
    "[&_tr:hover]:bg-opacity-50",
    "[&_tr]:transition-colors",
    "[&_th]:text-muted-foreground",
    "[&_th]:font-semibold",
    "[&_th]:p-6",
    "[&_th]:text-left",
    "[&_th]:align-middle",
    "[&_th]:whitespace-nowrap",
    "[&_td]:p-6",
    "[&_td]:font-inherit",
    "[&_td]:text-inherit",
    "[&_td]:align-middle",
    "[&_td]:whitespace-nowrap",
    {
      pattern: /(bg-gray)-(100|200|300|400)/
    },
    {
      pattern: /(bg-skeleton)-(100|200|300|400)/
    },
    {
      pattern: /line-clamp-(\d+)/,
      variants: ["sm", "md", "lg", "xl", "2xl"]
    },
    {
      pattern: /text-(xs|sm|base|lg|xl|2xl)/
    },
    {
      pattern: /grid|w-full|object-contain/,
      variants: ["md", "lg"]
    },
    {
      pattern: /overflow(-(x|y))?-(auto|hidden|visible)/,
      variants: ["md", "lg"]
    }
  ],
  darkMode: ["class"],
  content: ["./src/**/*.{ts,tsx,mdx}", "./app/**/*.{ts,tsx,mdx}", "./components/**/*.{ts,tsx,mdx}"],
  plugins: [pn],
  theme: {
    extend: {
      keyframes: {
        "accordion-down": {
          from: {
            height: "0"
          },
          to: {
            height: "var(--radix-accordion-content-height)"
          }
        },
        "accordion-up": {
          from: {
            height: "var(--radix-accordion-content-height)"
          },
          to: {
            height: "0"
          }
        }
      },
      animation: {
        "accordion-down": "accordion-down 0.2s ease-out",
        "accordion-up": "accordion-up 0.2s ease-out"
      }
    }
  }
}, gn = ln(mn), vn = gn?.theme?.screens, at = Yr({
  is2XL: !1,
  isXL: !1,
  isLG: !1,
  isMD: !1,
  isSM: !1,
  isMobile: !1,
  isPortrait: !1
}), wn = ({ children: e }) => {
  const [, u] = te({
    width: window.innerWidth,
    height: window.innerHeight
  }), a = lt(() => {
    u({ width: window.innerWidth, height: window.innerHeight });
  }, []);
  ee(() => (window.addEventListener("resize", a), () => window.removeEventListener("resize", a)), [a]);
  const o = Ze(() => Object.entries(vn).reduce(
    (d, [v, h]) => (d[v] = parseInt(`${h}`.replace("px", "")), d),
    {}
  ), []), i = re({ query: `(max-width: ${o.sm - 1}px)` }), n = re({
    query: `(min-width: ${o.sm}px)`
  }), r = re({
    query: `(min-width: ${o.md}px)`
  }), p = re({
    query: `(min-width: ${o.lg}px)`
  }), l = re({
    query: `(min-width: ${o.xl}px)`
  }), t = re({
    query: `(min-width: ${o["2xl"]}px)`
  }), f = re({ query: "(orientation: portrait)" }), c = Ze(() => ({
    is2XL: t,
    isXL: l,
    isLG: p,
    isMD: r,
    isSM: n,
    isPortrait: f,
    isMobile: i
  }), [t, l, p, r, n, f, i]);
  return /* @__PURE__ */ it.jsx(at.Provider, { value: c, children: e });
}, _n = () => Hr(at);
export {
  wn as R,
  _n as u
};
